<template>
  <div>
    <el-card shadow="hover">
      <template v-if="!embedded" slot="header">
        <div class="clearfix">
          <span>尊贵卡订单</span>
          <span class="muted small" style="margin-left: 12px">仅展示小程序业务员尊贵卡 A/B/C 的提交记录</span>
          <div style="float: right">
            <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
            <el-button v-if="$hasPerm('func:pickup:create')" type="primary" size="small" @click="openEdit(null)">新建提货申请</el-button>
          </div>
        </div>
      </template>

      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item v-if="!embedded" label="客户姓名">
          <el-input v-model="searchForm.customerName" placeholder="请输入" style="width: 160px" @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="提货类型">
          <el-select v-model="searchForm.outboundType" placeholder="全部" clearable style="width: 150px" @change="handleSearch">
            <el-option v-for="t in outboundTypeOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="存货类型">
          <el-select v-model="searchForm.stockType" placeholder="全部" clearable style="width: 130px" @change="handleSearch">
            <el-option label="普通存货" value="普通存货"></el-option>
            <el-option label="品鉴存货" value="品鉴存货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="礼品类型">
          <el-select v-model="searchForm.giftTypeId" placeholder="全部" clearable style="width: 140px" @change="handleSearch">
            <el-option v-for="t in allGiftTypeOptions" :key="t.id" :label="t.name" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.status" placeholder="全部" clearable style="width: 150px" @change="handleSearch">
            <el-option v-for="s in statusOptions" :key="s.value" :label="s.label" :value="s.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
        <el-form-item v-if="embedded" class="embed-actions">
          <el-button type="success" size="small" @click="exportCsv">导出CSV</el-button>
          <el-button v-if="$hasPerm('func:pickup:create')" type="primary" size="small" @click="openEdit(null)">新建提货申请</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="vipTable" :data="orderList" stripe size="small" border row-key="id" :expand-row-keys="expandedKeys" style="width: 100%">
        <el-table-column type="expand" width="40" :fixed="embedded ? false : 'left'">
          <template slot-scope="props">
            <div class="detail-panel">
              <div class="detail-panel-title"><i class="el-icon-info"></i><span>订单详情</span></div>
              <div class="detail-card-row">
                <div class="detail-card-body cols-4">
                  <div class="dc-cell"><span class="dc-label">订单ID</span><span class="dc-value">{{ props.row.id }}</span></div>
                  <div class="dc-cell"><span class="dc-label">申请单号</span><span class="dc-value">{{ props.row.applicationNo || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">客户姓名</span><span class="dc-value">{{ props.row.customerName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">出库类型</span>
                    <el-tag :type="cardTag(props.row)" :class="cardClass(props.row.cardName)" size="mini">{{ vipCardLabel(props.row) || '-' }}</el-tag>
                  </div>
                  <!-- 仅出库类型为试用时展示：试用类型与核验凭证 -->
                  <template v-if="['产品试用', '试用'].includes(props.row.cardName || props.row.outboundType)">
                    <div class="dc-cell"><span class="dc-label">试用类型</span><span class="dc-value">{{ props.row.applicableTypeName || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">核验方式/凭证</span>
                      <span class="dc-value">
                        <template v-if="props.row.verificationType === 1">
                          <el-tag size="mini" type="success" effect="plain"><i class="el-icon-mobile-phone"></i> 短信验证</el-tag>
                          <span v-if="props.row.verifyPhone" style="color:#409EFF;margin-left:6px;font-size:12px;font-weight:600">({{ props.row.verifyPhone }})</span>
                        </template>
                        <template v-else-if="props.row.verificationType === 2">
                          <el-tag size="mini" type="warning" effect="plain">特殊通道</el-tag>
                          <span v-if="props.row.attachmentUrl" style="margin-left:6px;display:inline-flex;align-items:center">
                            <el-image
                              v-if="isImageFile(props.row.attachmentUrl)"
                              style="width: 22px; height: 22px; border-radius: 2px; vertical-align: middle;"
                              :src="full(props.row.attachmentUrl)"
                              :preview-src-list="[full(props.row.attachmentUrl)]"
                            ></el-image>
                            <el-button
                              v-else
                              size="mini"
                              type="primary"
                              plain
                              icon="el-icon-download"
                              style="padding: 2px 6px; font-size: 11px; margin-left: 2px;"
                              @click="downloadAttachment(props.row.attachmentUrl)"
                            >
                              下载凭证
                            </el-button>
                          </span>
                          <span v-else class="muted" style="margin-left:4px;font-size:12px">（无凭证）</span>
                        </template>
                        <template v-else-if="props.row.verificationType === 3">
                          <el-tag size="mini" type="info" effect="plain">免核验</el-tag>
                        </template>
                        <template v-else>-</template>
                      </span>
                    </div>
                  </template>
                  <!-- 仅出库类型为礼品/损耗等礼品类时展示：礼品类型 -->
                  <template v-if="isGiftOutboundType(props.row.cardName || props.row.outboundType, props.row) || props.row.applicableTypeName">
                    <div class="dc-cell"><span class="dc-label">礼品类型</span><span class="dc-value">{{ props.row.applicableTypeName || '-' }}</span></div>
                  </template>
                  <div class="dc-cell"><span class="dc-label">产品内容</span><span class="dc-value">{{ prodContent(props.row) }}</span></div>
                  <template v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(props.row.cardName)">
                    <div class="dc-cell"><span class="dc-label">合同服务起始日</span><span class="dc-value">{{ String(props.row.serviceFeeStartDate || '').slice(0, 10) || '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">免服务费期限</span><span class="dc-value">{{ props.row.cardName === '尊贵卡A' ? '终身' : (props.row.freeServiceMonths != null ? (props.row.freeServiceMonths + ' 个月') : '-') }}</span></div>
                    <div class="dc-cell"><span class="dc-label">服务费起始日</span><span class="dc-value">{{ props.row.cardName === '尊贵卡A' ? '终身' : (computeServiceFeeStart(props.row.serviceFeeStartDate, props.row.freeServiceMonths) || '-') }}</span></div>
                    <div class="dc-cell"><span class="dc-label">服务费到期提醒</span><span class="dc-value">{{ props.row.cardName === '尊贵卡A' ? '终身' : (serviceRemindDate(props.row) || '-') }}</span></div>
                  </template>
                  <template v-if="props.row.cardName === '尊贵卡B'">
                    <div class="dc-cell highlight"><span class="dc-label">剩余额度</span><span class="dc-value highlight-value">{{ props.row.vipBRemaining != null ? '¥' + props.row.vipBRemaining : (props.row.quotaLimit != null && props.row.quotaLimit !== '' ? '¥' + props.row.quotaLimit : '-') }}</span></div>
                    <div class="dc-cell"><span class="dc-label">应该剩余额度</span><span class="dc-value" style="font-weight:600;">{{ props.row.shouldQuotaRemaining != null ? '¥' + props.row.shouldQuotaRemaining : (props.row.vipBRemaining != null ? '¥' + props.row.vipBRemaining : '-') }}</span></div>
                    <div class="dc-cell highlight"><span class="dc-label">实际剩余额度</span><span class="dc-value highlight-value" style="color:#67C23A;">{{ props.row.actualQuotaRemaining != null ? '¥' + props.row.actualQuotaRemaining : '¥0' }}</span></div>
                  </template>
                  <div class="dc-cell"><span class="dc-label">申请时间</span><span class="dc-value">{{ formatDateMinute(props.row.outboundDate, props.row) }} <el-tag v-if="isHistoryReplenishment(props.row)" type="warning" size="mini" style="margin-left:4px;">历史补录</el-tag></span></div>
                  <div class="dc-cell"><span class="dc-label">提交模式</span>
                    <span class="dc-value">
                      <el-tag v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(props.row.cardName)" :type="getReplenishTagType(props.row)" size="mini">{{ getReplenishTypeLabel(props.row) }}</el-tag>
                      <span v-else>-</span>
                    </span>
                  </div>
                  <div class="dc-cell"><span class="dc-label">订单状态</span>
                    <el-tag :type="statusTag(props.row.cardName, props.row.status)"
                            :effect="props.row.cardName === '新出库' && Number(props.row.status) === 4 ? 'dark' : 'light'"
                            :class="{ 'newout-uncompleted-tag': props.row.cardName === '新出库' && Number(props.row.status) === 4 }"
                            size="mini">{{ statusLabel(props.row.cardName, props.row.status) }}</el-tag>
                  </div>
                  <div class="dc-cell"><span class="dc-label">业务员</span><span class="dc-value">{{ props.row.userName || '-' }}</span></div>
                  <div class="dc-cell"><span class="dc-label">审核员</span><span class="dc-value">{{ props.row.approverName || '-' }}</span></div>
                  <div class="dc-cell w4">
                    <span class="dc-label">申请备注</span>
                    <span class="dc-value">
                      <!-- 按照需求暂时注释：展开行申请备注不自动拼接历史补录提示
                      <template v-if="isHistoryReplenishment(props.row)">
                        <span>{{ historyReplenishmentRemarkNote(props.row) }}</span>
                        <span v-if="props.row.remark && props.row.remark !== historyReplenishmentRemarkNote(props.row)" style="margin-left:8px;color:#873800;font-weight:normal;">（手填备注：{{ props.row.remark }}）</span>
                      </template>
                      <template v-else>
                        {{ props.row.remark || '-' }}
                      </template>
                      -->
                      {{ props.row.remark || '-' }}
                    </span>
                  </div>
                  <div class="dc-cell w4"><span class="dc-label">审核备注</span><span class="dc-value">
                    <template v-if="props.row.approveRemark">
                      <span v-if="proxyPrefix(props.row.approveRemark)" style="color:#E62412;font-weight:700">{{ proxyPrefix(props.row.approveRemark) }}</span>{{ proxyBody(props.row.approveRemark) || (proxyPrefix(props.row.approveRemark) ? '' : props.row.approveRemark) }}
                    </template>
                    <template v-else>-</template>
                  </span></div>
                  <div class="dc-cell w4"><span class="dc-label">驳回原因</span><span class="dc-value">
                    <template v-if="props.row.rejectRemark">
                      <span v-if="proxyPrefix(props.row.rejectRemark)" style="color:#E62412;font-weight:700">{{ proxyPrefix(props.row.rejectRemark) }}</span><span :style="proxyBody(props.row.rejectRemark) ? 'color:#f56c6c' : ''">{{ proxyBody(props.row.rejectRemark) || (proxyPrefix(props.row.rejectRemark) ? '' : props.row.rejectRemark) }}</span>
                    </template>
                    <template v-else>-</template>
                  </span></div>
                </div>
              </div>

              <!-- 订单明细：卡片栅格（同销售订单样式） -->
              <div class="detail-panel-title" style="margin-top: 14px;">
                <i class="el-icon-document"></i>
                <span>订单明细 · 共 {{ (props.row.details || []).length }} 项</span>
              </div>
              <div v-if="!(props.row.details || []).length" class="muted small">无明细</div>
              <div v-else class="detail-grid">
                <div v-for="(d, i) in props.row.details" :key="i" class="detail-card-row">
                  <div class="detail-card-head">
                    <span class="dc-no">#{{ i + 1 }}</span>
                    <span class="dc-name">{{ d.productName || '—' }}</span>
                    <span class="dc-spec" v-if="d.spec">规格：{{ d.spec }}</span>
                  </div>
                  <div class="detail-card-body">
                    <div class="dc-cell"><span class="dc-label">单价</span><span class="dc-value">{{ d.price != null ? '¥' + d.price : '-' }}</span></div>
                    <div class="dc-cell"><span class="dc-label">本次提货</span><span class="dc-value">{{ d.quantity || 0 }}</span></div>
                    <!-- 客户详情页内嵌的展开明细不显实付（客户要求）；独立页照常 -->
                    <div v-if="!embedded" class="dc-cell"><span class="dc-label">实付</span><span class="dc-value strong">{{ d.actualAmount != null ? '¥' + d.actualAmount : '-' }}</span></div>
                    <!-- 送存货：加 存货数量 + 剩余存货 -->
                    <template v-if="props.row.cardName === '送存货'">
                      <div class="dc-cell"><span class="dc-label">存货数量</span><span class="dc-value">{{ d.stockQuantity != null ? d.stockQuantity : '-' }}</span></div>
                      <div class="dc-cell highlight"><span class="dc-label">剩余存货</span><span class="dc-value highlight-value">{{ d.remainingStock != null ? d.remainingStock : (d.snapshotRemaining != null ? d.snapshotRemaining : '-') }}</span></div>
                    </template>
                    <!-- 尊贵卡A：加 领取上限 + 剩余可领取数量（终身卡，无服务费与休眠，不区分应该/实际剩余） -->
                    <template v-else-if="props.row.cardName === '尊贵卡A'">
                      <div class="dc-cell"><span class="dc-label">领取上限</span><span class="dc-value">{{ d.stockLimit != null ? d.stockLimit : '-' }}</span></div>
                      <div class="dc-cell highlight"><span class="dc-label">剩余可领取数量</span><span class="dc-value highlight-value">{{ d.remainingPickup != null ? d.remainingPickup : (d.snapshotRemaining != null ? d.snapshotRemaining : '-') }}</span></div>
                    </template>
                    <!-- 尊贵卡C：加 领取上限 + 剩余可领取数量 + 应该剩余 + 实际剩余；尊贵卡B 按金额扣，在卡级展现额度 -->
                    <template v-else-if="props.row.cardName === '尊贵卡C'">
                      <div class="dc-cell"><span class="dc-label">领取上限</span><span class="dc-value">{{ d.stockLimit != null ? d.stockLimit : '-' }}</span></div>
                      <div class="dc-cell highlight"><span class="dc-label">剩余可领取数量</span><span class="dc-value highlight-value">{{ d.remainingPickup != null ? d.remainingPickup : (d.snapshotRemaining != null ? d.snapshotRemaining : '-') }}</span></div>
                      <div class="dc-cell"><span class="dc-label">应该剩余</span><span class="dc-value" style="font-weight:600;">{{ d.shouldRemaining != null ? d.shouldRemaining : (d.snapshotShouldRemaining != null ? d.snapshotShouldRemaining : '-') }}</span></div>
                      <div class="dc-cell"><span class="dc-label">实际剩余</span><span class="dc-value" style="font-weight:600;color:#67C23A;">{{ d.actualRemaining != null ? d.actualRemaining : (d.snapshotActualRemaining != null ? d.snapshotActualRemaining : '-') }}</span></div>
                    </template>
                    <!-- 礼品/产品试用/新出库：无任何剩余字段 -->
                  </div>
                </div>
              </div>

              <!-- 高拍仪扫描：横向并排（礼品/产品试用 无需签字流程，不展示） -->
              <div class="sig-row" v-if="!['礼品','产品试用','试用'].includes(props.row.cardName)">
                <div class="sig-block">
                  <div class="section-title">现场拍照</div>
                  <div v-if="props.row.images" class="img-list">
                    <el-image v-for="(url, i) in (props.row.images || '').split(',').filter(Boolean)"
                              :key="i" :src="full(url)" :preview-src-list="(props.row.images || '').split(',').filter(Boolean).map(full)"
                              style="width:60px;height:60px;border-radius:4px;margin:0 4px 4px 0"></el-image>
                  </div>
                  <div v-else class="muted small">未上传</div>
                </div>
                <div class="sig-block">
                  <div class="section-title">客户签署</div>
                  <div v-if="props.row.customerSignature">
                    <el-image :src="full(props.row.customerSignature)" :preview-src-list="[full(props.row.customerSignature)]"
                              style="width:140px;height:80px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                  </div>
                  <div v-else class="muted small">未签署</div>
                </div>
                <div class="sig-block">
                  <div class="section-title">员工签署</div>
                  <div v-if="props.row.employeeSignature">
                    <el-image :src="full(props.row.employeeSignature)" :preview-src-list="[full(props.row.employeeSignature)]"
                              style="width:140px;height:80px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                  </div>
                  <div v-else class="muted small">未签署</div>
                </div>
                <div class="sig-block" v-if="props.row.signature">
                  <div class="section-title">拍照签名</div>
                  <el-image :src="full(props.row.signature)" :preview-src-list="[full(props.row.signature)]"
                            style="width:140px;height:80px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
        <el-table-column label="出库类型" min-width="150">
          <template slot-scope="s">
            <el-tag :type="cardTag(s.row)" :class="cardClass(s.row.cardName)" size="small">{{ vipCardLabel(s.row) || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="产品内容" min-width="200" show-overflow-tooltip>
          <!-- 客户详情页内嵌时列表只显产品名不带数量（展开行仍带）；独立页照常带数量 -->
          <template slot-scope="s">{{ embedded ? prodContentNoQty(s.row) : prodContent(s.row) }}</template>
        </el-table-column>
        <el-table-column label="数量" width="80" align="center">
          <template slot-scope="s">{{ rowQty(s.row) }}</template>
        </el-table-column>
        <!-- 客户详情页内嵌不显总实付金额（客户要求）；独立页照常 -->
        <el-table-column v-if="!embedded" label="总实付金额" width="110">
          <template slot-scope="s">¥{{ s.row.totalAmount || 0 }}</template>
        </el-table-column>
        <el-table-column label="申请时间" min-width="150" align="center">
          <template slot-scope="s">
            <div>{{ formatDateMinute(s.row.applicationTime || s.row.outboundDate, s.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="真实提交时间" min-width="175" align="center">
          <template slot-scope="s">
            <div>{{ formatFullTime(s.row.createTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="s">
            <el-tag :type="statusTag(s.row.cardName, s.row.status)"
                    :effect="s.row.cardName === '新出库' && Number(s.row.status) === 4 ? 'dark' : 'light'"
                    :class="{ 'newout-uncompleted-tag': s.row.cardName === '新出库' && Number(s.row.status) === 4 }"
                    size="small">{{ statusLabel(s.row.cardName, s.row.status) }}</el-tag>
            <span v-if="s.row.status === 2 && s.row.rejectRemark" style="margin-left:6px;color:#f56c6c;font-size:12px;" :title="s.row.rejectRemark">原因：{{ s.row.rejectRemark }}</span>
          </template>
        </el-table-column>
        <el-table-column label="业务员" width="100">
          <template slot-scope="s">{{ s.row.userName || '-' }}</template>
        </el-table-column>
        <el-table-column label="审核员" width="100">
          <template slot-scope="s">{{ s.row.approverName || '-' }}</template>
        </el-table-column>
        <el-table-column label="申请备注" min-width="150" show-overflow-tooltip>
          <template slot-scope="s">
            {{ s.row.remark || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="id" label="订单ID" width="80"></el-table-column>
        <el-table-column label="操作" width="260" :fixed="embedded ? false : 'right'" align="center">
          <template slot-scope="s">
            <!-- 审核中/已驳回 可改；超管自建申请在出库前(status≠3)也可改；其它状态置灰 -->
            <el-button v-if="$hasPerm('func:pickup:edit')" size="mini"
                       :type="canEditRow(s.row) ? 'primary' : 'info'"
                       :disabled="!canEditRow(s.row)"
                       @click="openEdit(s.row)">修改</el-button>
            <el-button v-if="$hasPerm('func:pickup:cancel')" size="mini" type="warning" :disabled="Number(s.row.status) === 6"
                       @click="handleCancel(s.row)">撤销</el-button>
            <el-button v-if="$hasPerm('func:pickup:delete')" size="mini" type="danger" @click="handleDelete(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; loadList() }"
          @current-change="p => { currentPage = p; loadList() }"
          :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>

    <!-- 详情抽屉：含签署/拍照 -->
    <el-drawer title="订单详情" :visible.sync="detailVisible" size="720px" direction="rtl">
      <div v-if="detail" style="padding: 0 20px 24px">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="订单ID">{{ detail.id }}</el-descriptions-item>
          <el-descriptions-item label="申请单号">{{ detail.applicationNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="客户姓名">{{ detail.customerName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="出库类型">
            <el-tag :type="cardTag(detail)" :class="cardClass(detail.cardName)" size="mini">{{ vipCardLabel(detail) || '-' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="提交模式">
            <el-tag v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(detail.cardName)" :type="getReplenishTagType(detail)" size="mini">{{ getReplenishTypeLabel(detail) }}</el-tag>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item v-if="['产品试用', '试用'].includes(detail.cardName || detail.outboundType)" label="试用类型">
            {{ detail.applicableTypeName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item v-if="isGiftOutboundType(detail.cardName || detail.outboundType, detail) || detail.applicableTypeName" label="礼品类型">
            {{ detail.applicableTypeName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item v-if="['产品试用', '试用'].includes(detail.cardName || detail.outboundType)" label="核验方式/凭证">
            <template v-if="detail.verificationType === 1">
              <el-tag size="mini" type="success" effect="plain"><i class="el-icon-mobile-phone"></i> 短信验证</el-tag>
              <span v-if="detail.verifyPhone" style="color:#409EFF;margin-left:6px;font-weight:600">({{ detail.verifyPhone }})</span>
            </template>
            <template v-else-if="detail.verificationType === 2">
              <el-tag size="mini" type="warning" effect="plain">特殊通道</el-tag>
              <span v-if="detail.attachmentUrl" style="margin-left:8px;display:inline-flex;align-items:center">
                <el-image
                  v-if="isImageFile(detail.attachmentUrl)"
                  style="width: 28px; height: 28px; border-radius: 4px; vertical-align: middle"
                  :src="full(detail.attachmentUrl)"
                  :preview-src-list="[full(detail.attachmentUrl)]"
                ></el-image>
                <el-button
                  v-else
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-download"
                  style="padding: 3px 8px; font-size: 11px; margin-left: 4px;"
                  @click="downloadAttachment(detail.attachmentUrl)"
                >
                  下载凭证
                </el-button>
              </span>
              <span v-else class="muted" style="margin-left:6px">（未上传凭证）</span>
            </template>
            <template v-else-if="detail.verificationType === 3">
              <el-tag size="mini" type="info" effect="plain">免核验</el-tag>
            </template>
            <template v-else>-</template>
          </el-descriptions-item>
          <el-descriptions-item label="产品内容" :span="2">{{ prodContent(detail) }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.cardName === '尊贵卡C'" label="免服务费期限">{{ detail.freeServicePeriod || '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.cardName === '尊贵卡C'" label="服务费起始日">{{ formatDate(detail.serviceFeeStartDate, 10) || '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.cardName === '尊贵卡C'" label="服务期限" content-class-name="hl-content" label-class-name="hl-label">{{ computeServiceTerm(detail) || '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.cardName === '尊贵卡C'" label="提醒日期">{{ formatDate(detail.reminderDate, 10) || '-' }}</el-descriptions-item>
          <el-descriptions-item v-if="detail.cardName === '尊贵卡B'" label="剩余额度" content-class-name="hl-content" label-class-name="hl-label">{{ detail.quotaLimit != null && detail.quotaLimit !== '' ? '¥' + detail.quotaLimit : '-' }}</el-descriptions-item>
          <el-descriptions-item label="销售日期">{{ formatDate(detail.createTime) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">
            <el-tag :type="statusTag(detail.cardName, detail.status)"
                    :effect="detail.cardName === '新出库' && Number(detail.status) === 4 ? 'dark' : 'light'"
                    :class="{ 'newout-uncompleted-tag': detail.cardName === '新出库' && Number(detail.status) === 4 }"
                    size="mini">{{ statusLabel(detail.cardName, detail.status) }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="业务员">{{ detail.userName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核员">{{ detail.approverName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="申请备注" :span="2">{{ detail.remark || '-' }}</el-descriptions-item>
          <el-descriptions-item label="驳回原因" :span="2">
            <span v-if="detail.rejectRemark" style="color:#f56c6c">{{ detail.rejectRemark }}</span>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>

        <div class="section-title">明细</div>
        <el-table v-if="detail.details && detail.details.length" :data="detail.details" size="mini" border
                  show-summary :summary-method="detailSummary">
          <el-table-column prop="productName" label="产品" min-width="120"></el-table-column>
          <el-table-column prop="spec" label="规格" width="110">
            <template slot-scope="s">{{ s.row.spec || '-' }}</template>
          </el-table-column>
          <el-table-column label="单价" width="90">
            <template slot-scope="s">{{ s.row.price != null ? '¥' + s.row.price : '-' }}</template>
          </el-table-column>
          <el-table-column prop="quantity" label="本次提货" width="90"></el-table-column>
          <el-table-column label="实付" width="100">
            <template slot-scope="s">{{ s.row.actualAmount != null ? '¥' + s.row.actualAmount : '-' }}</template>
          </el-table-column>
          <el-table-column v-if="detail.cardName === '尊贵卡A' || detail.cardName === '尊贵卡C'" prop="stockLimit" label="领取上限" width="90">
            <template slot-scope="s">{{ s.row.stockLimit != null ? s.row.stockLimit : '-' }}</template>
          </el-table-column>
          <el-table-column prop="stockQuantity" label="存货数量" width="90">
            <template slot-scope="s">{{ s.row.stockQuantity != null ? s.row.stockQuantity : '-' }}</template>
          </el-table-column>
          <el-table-column prop="remainingStock" label="剩余存货" width="90"></el-table-column>
        </el-table>
        <div v-else class="muted small">无明细</div>

        <div class="section-title">现场拍照</div>
        <div v-if="detail.images" class="img-list">
          <el-image v-for="(url, i) in (detail.images || '').split(',').filter(Boolean)"
                    :key="i" :src="full(url)" :preview-src-list="(detail.images || '').split(',').filter(Boolean).map(full)"
                    style="width:64px;height:64px;border-radius:4px;margin:0 4px 4px 0"></el-image>
        </div>
        <div v-else class="muted small">未上传</div>

        <div class="section-title">客户签署</div>
        <div v-if="detail.customerSignature">
          <el-image :src="full(detail.customerSignature)" :preview-src-list="[full(detail.customerSignature)]"
                    style="width:160px;height:90px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
        </div>
        <div v-else class="muted small">未签署</div>

        <div class="section-title">员工签署</div>
        <div v-if="detail.employeeSignature">
          <el-image :src="full(detail.employeeSignature)" :preview-src-list="[full(detail.employeeSignature)]"
                    style="width:160px;height:90px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
        </div>
        <div v-else class="muted small">未签署</div>

        <div v-if="detail.signature" class="section-title">拍照签名</div>
        <div v-if="detail.signature">
          <el-image :src="full(detail.signature)" :preview-src-list="[full(detail.signature)]"
                    style="width:160px;height:90px;object-fit:contain;border:1px solid #ebeef5;border-radius:4px"></el-image>
        </div>
      </div>
    </el-drawer>

    <!-- 新建/修改弹窗 -->
    <el-dialog :title="form.id ? '修改提货申请' : '新建提货申请'" :visible.sync="editVisible" width="780px" top="6vh" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
      <el-form :model="form" label-width="100px" size="small">
        <el-row :gutter="16">
          <el-col :span="form.cardName === '送存货' ? 8 : 12"><el-form-item label="客户姓名" required>
            <el-input v-model="form.customerName" placeholder="请输入并失焦自动查询" @blur="lookupCustomerInfo" :disabled="embedded && !form.id"></el-input>
          </el-form-item></el-col>
          <el-col :span="form.cardName === '送存货' ? 8 : 12"><el-form-item label="出库类型" required>
            <el-select v-model="form.cardName" placeholder="选择类型" style="width:100%">
              <el-option v-for="t in cardOptions" :key="t.value" :label="t.label" :value="t.value"></el-option>
            </el-select>
          </el-form-item></el-col>
          <el-col v-if="form.cardName === '送存货'" :span="8"><el-form-item label="存货类型" required>
            <el-select v-model="form.stockType" placeholder="选择存货类型" style="width:100%">
              <el-option label="普通存货" value="普通存货"></el-option>
              <el-option label="品鉴存货" value="品鉴存货"></el-option>
            </el-select>
          </el-form-item></el-col>
        </el-row>

        <!-- 礼品类型选择（仅当出库类型为礼品时展开） -->
        <template v-if="isGiftOutbound">
          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="礼品类型" required>
                <el-select
                  v-model="form.applicableTypeId"
                  placeholder="请选择礼品类型"
                  style="width:100%"
                  @change="onGiftTypeChange"
                  :disabled="giftTypeOptions.length <= 1"
                >
                  <el-option
                    v-for="t in giftTypeOptions"
                    :key="t.id"
                    :label="t.name"
                    :value="t.id"
                  >
                    <span style="float:left">{{ t.name }}</span>
                    <span v-if="t.customerCategoryName" style="float:right;color:#8492a6;font-size:12px">{{ t.customerCategoryName }}</span>
                  </el-option>
                </el-select>
                <div v-if="giftTypeOptions.length === 0" style="color:#F56C6C;font-size:12px;margin-top:4px;">
                  <i class="el-icon-warning"></i> 该客户在礼品名单中未配置任何礼品分类权限，无法申请礼品。
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <!-- 试用类型及核验机制（仅当出库类型为试用时展开） -->
        <template v-if="isTrialOutbound">
          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item label="试用类型" required>
                <el-select v-model="form.applicableTypeId" placeholder="请选择试用类型" style="width:100%" @change="onTrialTypeChange">
                  <el-option v-for="t in trialTypeOptions" :key="t.id" :label="t.name" :value="t.id">
                    <span style="float:left">{{ t.name }}</span>
                    <span v-if="t.needVerification === 1" style="float:right;color:#E6A23C;font-size:12px">需核验</span>
                    <span v-else style="float:right;color:#909399;font-size:12px">免核验</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="currentTrialType && currentTrialType.needVerification === 1" :gutter="16">
            <el-col :span="24">
              <el-form-item label="核验方式" required>
                <el-radio-group v-model="form.verificationType">
                  <el-radio :label="1">短信验证</el-radio>
                  <el-radio :label="2">特殊通道（凭证附件）</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 短信验证 -->
          <template v-if="currentTrialType && currentTrialType.needVerification === 1 && form.verificationType === 1">
            <el-row :gutter="16">
              <el-col :span="15">
                <el-form-item label="核验手机号" required>
                  <el-input v-model="form.verifyPhone" placeholder="请输入11位手机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-button
                  type="primary"
                  plain
                  size="small"
                  style="width:100%;"
                  :disabled="smsCountdown > 0 || !form.verifyPhone"
                  @click="sendSmsCode"
                >
                  {{ smsCountdown > 0 ? `${smsCountdown}s后重新获取` : '获取验证码' }}
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="24">
                <el-form-item label="短信验证码" required>
                  <el-input v-model="form.smsCode" placeholder="请输入6位短信验证码" maxlength="6"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </template>

          <!-- 特殊通道附件 -->
          <template v-if="currentTrialType && currentTrialType.needVerification === 1 && form.verificationType === 2">
            <el-row :gutter="16">
              <el-col :span="24">
                <el-form-item label="凭证附件" required>
                  <el-upload
                    :action="uploadUrl"
                    :http-request="customUploadVoucher"
                    :show-file-list="false"
                    :before-upload="beforeVoucherUpload"
                  >
                    <el-button size="small" type="primary" plain icon="el-icon-upload2">上传凭证文件</el-button>
                    <span class="muted small" style="margin-left:10px;font-size:12px;">支持图片、PDF、Word、Excel等格式</span>
                  </el-upload>
                  <div v-if="form.attachmentUrl" style="margin-top:8px;display:flex;align-items:center;background:#f5f7fa;padding:6px 12px;border-radius:4px;border:1px solid #e4e7ed;">
                    <i class="el-icon-document" style="font-size:16px;color:#409EFF;margin-right:8px;"></i>
                    <span style="flex:1;font-size:13px;color:#606266;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ form.attachmentName || '凭证附件' }}</span>
                    <el-button size="mini" type="text" style="color:#409EFF;margin-right:8px;" @click="previewOrDownload(form.attachmentUrl)">预览/下载</el-button>
                    <el-button size="mini" type="text" style="color:#F56C6C;" icon="el-icon-delete" @click="removeVoucher">删除</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </template>
        <!-- 多张同类卡时让用户选具体哪张卡（≥2 才显示；=1 自动选） -->
        <el-row v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.cardName) && vipCardOptions.length >= 2" :gutter="16">
          <el-col :span="24"><el-form-item label="选择卡" required>
            <el-select v-model="form.orderId" placeholder="请选择" style="width:100%" @change="onVipCardChange">
              <el-option v-for="c in vipCardOptions" :key="c.id" :label="c.label" :value="c.id"></el-option>
            </el-select>
          </el-form-item></el-col>
        </el-row>
        <el-row v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.cardName) && form.orderId && getSelectedCardServiceYearWindow()" :gutter="16">
          <el-col :span="24"><el-form-item label="当前服务年度">
            <el-input :value="getSelectedCardServiceYearWindow()" disabled style="font-weight:600;color:#409EFF;"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row v-if="['尊贵卡B','尊贵卡C'].includes(form.cardName) && form.customerName" :gutter="16">
          <el-col :span="24"><el-form-item label="服务费到期时间">
            <el-input :value="vipDialogServiceTerm" disabled :style="serviceFeeOverdue ? 'color:#f56c6c' : ''"></el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row v-if="form.cardName === '尊贵卡B' && form.customerName" :gutter="16">
          <el-col :span="12"><el-form-item label="剩余额度">
            <el-input :value="vipDialogQuota" disabled>
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="实际剩余额度">
            <el-input :value="vipDialogActualQuota" disabled style="color:#67C23A;font-weight:600;">
              <template slot="prepend">¥</template>
            </el-input>
          </el-form-item></el-col>
        </el-row>
        <el-row v-if="serviceFeeWarning && ['尊贵卡B','尊贵卡C'].includes(form.cardName)" :gutter="16">
          <el-col :span="24">
            <div style="margin:-8px 0 14px 100px;color:#f56c6c;font-size:12px;">{{ serviceFeeWarning }}</div>
          </el-col>
        </el-row>

        <el-row v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.cardName)" :gutter="16">
          <el-col :span="24">
            <el-form-item label="提交模式" required>
              <el-radio-group v-model="form.replenishType" @change="onReplenishTypeChange">
                <el-radio v-if="$hasPerm('func:pickup:replenish-cross-year')" label="cross_year">跨年度补录</el-radio>
                <el-radio v-if="['尊贵卡B','尊贵卡C'].includes(form.cardName) && $hasPerm('func:pickup:replenish-in-year')" label="in_year">本年度内补录</el-radio>
                <el-radio label="normal">{{ form.cardName === '尊贵卡A' ? '本年度提交' : '正常提交' }}</el-radio>
              </el-radio-group>
              <div class="muted small" style="margin-top:4px;color:#E6A23C;font-size:12px;line-height:1.5;">
                <template v-if="form.cardName === '尊贵卡A'">
                  <template v-if="form.replenishType === 'cross_year'">跨年度补录不扣除本年度剩余可领取数量</template>
                  <template v-else>本年度提交扣除本年度的剩余可领取数量</template>
                </template>
                <template v-else>
                  <template v-if="form.replenishType === 'cross_year'">跨年度补录不扣除本年度应该剩余和实际剩余（或额度）</template>
                  <template v-else-if="form.replenishType === 'in_year'">本年度内补录只扣除应该剩余，不扣除实际剩余</template>
                  <template v-else>正常提交扣除本年度应该剩余+实际剩余</template>
                </template>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="24"><el-form-item label="申请时间" required>
            <div style="display:flex;align-items:center;max-width:540px;">
              <el-date-picker
                v-model="formDatePart"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                :disabled="isAppTimeDisabled"
                popper-class="sales-order-date-popper"
                :style="['尊贵卡B','尊贵卡C'].includes(form.cardName) ? 'width:50%' : 'width:100%'"
                @change="syncOutboundDateTime">
              </el-date-picker>
              <template v-if="['尊贵卡B','尊贵卡C'].includes(form.cardName)">
                <el-time-picker
                  v-model="formTimePart"
                  format="HH:mm"
                  value-format="HH:mm"
                  placeholder="选择时间(可直接输入)"
                  :picker-options="timePickerOptions"
                  :disabled="isAppTimeDisabled"
                  popper-class="sales-order-date-popper"
                  style="width:36%;margin-left:2%"
                  @change="syncOutboundDateTime">
                </el-time-picker>
                <el-button size="mini" type="primary" plain :disabled="isAppTimeDisabled" style="width:12%;margin-left:2%;padding:6px 0;" @click="setFormToNow">此刻</el-button>
              </template>
            </div>
          </el-form-item></el-col>
        </el-row>
        <el-row v-if="['尊贵卡A','尊贵卡B','尊贵卡C'].includes(form.cardName) && historyReplenishmentHintText" :gutter="16">
          <el-col :span="24">
            <div class="history-replenish-dialog-banner">
              <i class="el-icon-warning-outline" style="font-size:16px;"></i>
              <div><strong>历史补录提示</strong>：{{ historyReplenishmentHintText }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="业务员" required>
            <el-select v-model="form.salesmanId" filterable placeholder="选择业务员" style="width:100%" :disabled="embedded">
              <el-option v-for="u in salesmanOptions" :key="u.id" :label="u.name || u.username" :value="u.id"></el-option>
            </el-select>
            <div class="select-hint">{{ embedded ? '已自动锁定为当前客户负责人' : '仅展示有此出库类型权限的业务员' }}</div>
          </el-form-item></el-col>
          <el-col :span="12"><el-form-item label="审核员" required>
            <el-select v-model="form.approverId" filterable clearable placeholder="选择审核员（行政管理员）" style="width:100%">
              <el-option v-for="u in adminOptions" :key="u.id" :label="u.name || u.username" :value="u.id"></el-option>
            </el-select>
            <div class="select-hint">仅展示有此出库类型审批权限的行政管理员</div>
          </el-form-item></el-col>
        </el-row>

        <el-form-item label="申请备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入"></el-input>
        </el-form-item>

        <el-divider content-position="left">产品明细</el-divider>
        <div v-for="(d, idx) in form.details" :key="idx" class="detail-card">
          <el-row :gutter="16" align="middle">
            <el-col :span="12">
              <el-select v-model="d.productOptKey" filterable :placeholder="isGiftOutbound && !form.applicableTypeId ? '请先选择礼品类型' : (isGiftOutbound ? '选择礼品' : '选择产品')" :disabled="isGiftOutbound && !form.applicableTypeId" style="width:100%" @change="onDetailProductChange(d)">
                <!-- label 用裸名（决定选中后显示，不带后缀）；下拉面板用插槽显示带「（剩余存货/可领取 N）」 -->
                <el-option v-for="p in productOpts" :key="p.optKey" :label="stripStockSuffix(p.name)" :value="p.optKey">{{ p.name }}</el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-input-number v-model="d.quantity" :min="1" controls-position="right" style="width:100%" placeholder="数量"></el-input-number>
            </el-col>
            <el-col :span="4">
              <el-button v-if="form.details.length > 1" size="mini" type="text" icon="el-icon-delete" @click="form.details.splice(idx, 1)">删除</el-button>
            </el-col>
          </el-row>
          <!-- 试用提示文案 (红/绿/灰三态) -->
          <div v-if="isTrialOutbound && d.tipMessage" :style="getTrialTipStyle(d)" style="margin-top:6px;font-size:12px;padding:2px 0;">
            {{ d.tipMessage }}
          </div>
        </div>
        <el-button size="mini" type="primary" plain icon="el-icon-plus" @click="addDetailRow">{{ isGiftOutbound ? '添加礼品' : '添加产品' }}</el-button>

        <!-- 修改时附件上传区域已去掉 -->

      </el-form>
      <div slot="footer">
        <el-button size="small" @click="editVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitEdit" :loading="submitting">保存</el-button>
      </div>
    </el-dialog>

    <!-- 变更记录抽屉 -->
    <el-drawer title="变更记录" :visible.sync="changeLogVisible" size="560px" direction="rtl">
      <div style="padding: 0 20px 24px">
        <el-timeline v-if="changeLogs.length">
          <el-timeline-item v-for="log in changeLogs" :key="log.id" :timestamp="formatDate(log.changeTime)" placement="top">
            <el-card shadow="hover">
              <div><strong>{{ log.fieldName }}</strong> 变更</div>
              <div class="muted small" style="margin-top:4px">操作人：{{ log.operator || '-' }}</div>
              <div style="margin-top:8px">
                <div class="muted small">原值：</div>
                <div v-if="log.oldValue" class="cl-files">
                  <el-image v-for="(u, i) in splitUrls(log.oldValue)" :key="'o'+i"
                            :src="full(u)" :preview-src-list="splitUrls(log.oldValue).map(full)"
                            style="width:64px;height:64px;border-radius:4px;margin:2px"></el-image>
                </div>
                <div v-else class="muted small">无</div>
                <div class="muted small" style="margin-top:6px">新值：</div>
                <div v-if="log.newValue" class="cl-files">
                  <el-image v-for="(u, i) in splitUrls(log.newValue)" :key="'n'+i"
                            :src="full(u)" :preview-src-list="splitUrls(log.newValue).map(full)"
                            style="width:64px;height:64px;border-radius:4px;margin:2px"></el-image>
                </div>
                <div v-else class="muted small">无</div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <el-empty v-else description="暂无变更记录"></el-empty>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'VipOrder',
  props: {
    embeddedCustomer: { type: Object, default: null }
  },
  data() {
    return {
      searchForm: { customerName: '', outboundType: '', stockType: '', giftTypeId: '', status: '' },
      outboundTypeOptions: [
        { label: '尊贵卡A', value: '尊贵卡A' },
        { label: '尊贵卡B', value: '尊贵卡B' },
        { label: '尊贵卡C', value: '尊贵卡C' },
        { label: '送存货', value: '送存货' },
        { label: '礼品', value: '礼品' },
        { label: '产品试用', value: '试用' },
        { label: '新出库', value: '新出库' }
      ],
      formDatePart: '',
      formTimePart: '',
      orderList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailVisible: false,
      detail: null,
      editVisible: false,
      submitting: false,
      form: this.emptyForm(),
      productOpts: [],
      salesmanOptions: [],
      adminOptions: [],
      expandedKeys: [],
      // 包含所有标准出库类型（尊贵卡A/B/C、送存货、礼品、产品试用、新出库） + 该客户销售订单出现过的其它 category
      cardOptions: [
        { label: '尊贵卡A', value: '尊贵卡A' },
        { label: '尊贵卡B', value: '尊贵卡B' },
        { label: '尊贵卡C', value: '尊贵卡C' },
        { label: '送存货', value: '送存货' },
        { label: '礼品', value: '礼品' },
        { label: '产品试用', value: '试用' },
        { label: '新出库', value: '新出库' }
      ],
      // 服务费休眠缓冲期配置
      bufferValue: 10,
      bufferUnit: 'day',
      vipDialogQuota: '',
      vipDialogActualQuota: '',
      vipDialogServiceTerm: '',
      vipDialogRemainPickup: '',
      serviceFeeOverdue: false,
      serviceFeeWarning: '',
      vipCardOptions: [],
      changeLogVisible: false,
      changeLogs: [],
      statusOptions: [
        { value: 0, label: '审核中' },
        { value: 2, label: '已驳回' },
        { value: 1, label: '待签字' },
        { value: 3, label: '已完结' },
        { value: 4, label: '未完结' },
        { value: 6, label: '已撤销' }
      ],
      songCunHuoMinDate: '',
      isOpeningEdit: false,
      // 当前登录用户（mounted 时从 /user/info 拉真实角色）
      currentUser: null,
      trialTypeOptions: [],
      giftTypeOptions: [],
      allGiftTypeOptions: [],
      allGiftList: [],
      outboundTypes: [],
      smsCountdown: 0,
      smsTimer: null,
      customerPhoneMap: {}
    }
  },
  computed: {
    embedded() { return !!(this.embeddedCustomer && this.embeddedCustomer.id) },
    isTrialOutbound() { return ['试用', '产品试用'].includes(this.form.cardName) },
    currentTrialType() { return (this.trialTypeOptions || []).find(t => t.id === this.form.applicableTypeId) || null },
    isGiftOutbound() { return this.form.cardName === '礼品' },
    currentGiftType() { return (this.giftTypeOptions || []).find(t => t.id === this.form.applicableTypeId) || null },
    uploadUrl() { return (axios.defaults.baseURL || '') + '/file/upload' },
    uploadHeaders() {
      const t = sessionStorage.getItem('token')
      return t ? { Authorization: 'Bearer ' + t } : {}
    },
    minOutboundDateStr() {
      const card = this.form.cardName
      if (!card || !['尊贵卡A', '尊贵卡B', '尊贵卡C', '送存货'].includes(card)) {
        return ''
      }
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(card)) {
        let sel = null
        if (this.form.orderId) {
          sel = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
        } else if ((this.vipCardOptions || []).length > 0) {
          sel = this.vipCardOptions[0]
        }
        if (sel) {
          const start = String(sel.serviceFeeStartDate || sel.saleDate || sel.createTime || '').slice(0, 10)
          if (start) return start
        }
        // 若未命中具体单卡，回落查找所有卡中的最早合同服务起始日
        let minD = ''
        ;(this.vipCardOptions || []).forEach(c => {
          const dt = String(c.serviceFeeStartDate || c.saleDate || c.createTime || '').slice(0, 10)
          if (dt && (!minD || dt < minD)) minD = dt
        })
        if (minD) return minD
      } else if (card === '送存货') {
        if (this.songCunHuoMinDate) return this.songCunHuoMinDate
      }
      return ''
    },
    isAppTimeDisabled() {
      const card = this.form.cardName
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(card)) return false
      let selCard = null
      if (this.form.orderId) {
        selCard = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
      } else if ((this.vipCardOptions || []).length > 0) {
        selCard = this.vipCardOptions[0]
      }
      if (!selCard) return false
      const contractStartStr = String(selCard.serviceFeeStartDate || '').slice(0, 10)
      if (!contractStartStr) return false
      const pad = n => String(n).padStart(2, '0')
      const today = new Date()
      const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`

      // 规则 1：未来卡（today < 合同服务起始日）→ 无论哪种模式，全部置灰！
      if (todayStr < contractStartStr) {
        return true
      }
      // 计算当前服务年度起点
      const winStartStr = this.getCardWindowStartStr(selCard) || contractStartStr
      const replenish = this.form.replenishType || 'normal'

      // 规则 2：【跨年度补录】模式下，若 contractStartStr == winStartStr（处于第1服务年度）→ 全部置灰！
      if (replenish === 'cross_year') {
        if (contractStartStr === winStartStr) {
          return true
        }
      }
      // 规则 3：【本年度补录】模式下：
      if (replenish === 'in_year') {
        // 3.1 今天恰好是服务年度第1天 → 置灰！
        if (todayStr === winStartStr) {
          return true
        }
        // 3.2 实际剩余时间在服务年度第1天或之前（无可选的前一天） → 置灰！
        const actTime = selCard.actualUpdateTime || selCard.orderActualUpdateTime
        if (actTime) {
          const actStr = String(actTime).replace('T', ' ').slice(0, 10)
          if (actStr <= winStartStr) {
            return true
          }
        }
      }
      return false
    },
    getCardBoundaryDates() {
      let selCard = null
      if (this.form.orderId) {
        selCard = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
      } else if ((this.vipCardOptions || []).length > 0) {
        selCard = this.vipCardOptions[0]
      }
      const pad = n => String(n).padStart(2, '0')
      const today = new Date()
      const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`

      if (!selCard) {
        selCard = { cardName: this.form.cardName, serviceFeeStartDate: todayStr, createTime: today }
      }
      let contractStartStr = String(selCard.serviceFeeStartDate || selCard.createTime || '').slice(0, 10)
      if (!contractStartStr) contractStartStr = this.minOutboundDateStr || todayStr

      let winStartStr = this.getCardWindowStartStr(selCard)
      if (!winStartStr) winStartStr = contractStartStr

      let actualUpdateStr = ''
      const actTime = selCard.actualUpdateTime || selCard.orderActualUpdateTime
      if (actTime) {
        actualUpdateStr = String(actTime).replace('T', ' ').slice(0, 10)
      }
      let winEndStr = ''
      if (winStartStr) {
        const parts = winStartStr.split('-').map(Number)
        if (parts.length === 3 && !parts.some(isNaN)) {
          const endDate = new Date(parts[0] + 1, parts[1] - 1, parts[2] - 1)
          winEndStr = `${endDate.getFullYear()}-${pad(endDate.getMonth() + 1)}-${pad(endDate.getDate())}`
        }
      }

      // 【本年度补录】上限 (inYearUpperStr)：实际剩余时间的前一天（绝不能到当天！）
      let inYearUpperStr = ''
      if (actualUpdateStr && actualUpdateStr >= winStartStr && actualUpdateStr <= winEndStr) {
        const parts = actualUpdateStr.split('-').map(Number)
        if (parts.length === 3 && !parts.some(isNaN)) {
          const prevDate = new Date(parts[0], parts[1] - 1, parts[2] - 1)
          inYearUpperStr = `${prevDate.getFullYear()}-${pad(prevDate.getMonth() + 1)}-${pad(prevDate.getDate())}`
        }
      } else {
        const parts = todayStr.split('-').map(Number)
        if (parts.length === 3 && !parts.some(isNaN)) {
          const prevDate = new Date(parts[0], parts[1] - 1, parts[2] - 1)
          inYearUpperStr = `${prevDate.getFullYear()}-${pad(prevDate.getMonth() + 1)}-${pad(prevDate.getDate())}`
        }
      }

      // 【正常提交】起点 (normalMinDate)：
      let normalMinDate = winStartStr
      if (actualUpdateStr && actualUpdateStr >= winStartStr && actualUpdateStr <= winEndStr) {
        normalMinDate = actualUpdateStr
      } else {
        normalMinDate = todayStr < winStartStr ? winStartStr : todayStr
      }

      return { contractStartStr, winStartStr, actualUpdateStr, inYearUpperStr, normalMinDate, winEndStr, todayStr }
    },
    pickerOptions() {
      const card = this.form.cardName
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(card)) {
        const bounds = this.getCardBoundaryDates
        const replenish = this.form.replenishType || 'normal'
        return {
          disabledDate(time) {
            const pad = n => String(n).padStart(2, '0')
            const dStr = `${time.getFullYear()}-${pad(time.getMonth() + 1)}-${pad(time.getDate())}`
            if (replenish === 'cross_year') {
              return dStr < bounds.contractStartStr || dStr >= bounds.winStartStr
            } else if (replenish === 'in_year') {
              return dStr < bounds.winStartStr || dStr > bounds.inYearUpperStr
            } else {
              return dStr < bounds.normalMinDate || dStr > bounds.winEndStr
            }
          }
        }
      }

      const minStr = this.minOutboundDateStr
      if (!minStr) return {}
      const parts = minStr.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return {}
      const minDate = new Date(parts[0], parts[1] - 1, parts[2])
      minDate.setHours(0, 0, 0, 0)
      return {
        disabledDate(time) {
          return time.getTime() < minDate.getTime()
        }
      }
    },
    timePickerOptions() {
      const card = this.form.cardName
      if (['尊贵卡B', '尊贵卡C'].includes(card) && (this.form.replenishType || 'normal') === 'normal') {
        const bounds = this.getCardBoundaryDates
        const actStr = bounds.actualUpdateStr
        if (actStr && bounds.winStartStr <= actStr && actStr <= bounds.winEndStr && this.formDatePart === actStr) {
          let selCard = null
          if (this.form.orderId) {
            selCard = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
          } else if ((this.vipCardOptions || []).length > 0) {
            selCard = this.vipCardOptions[0]
          }
          const actTime = selCard ? (selCard.actualUpdateTime || selCard.orderActualUpdateTime) : null
          if (actTime) {
            const timeStr = String(actTime).replace('T', ' ').slice(11, 16)
            if (timeStr && timeStr.length === 5) {
              const parts = timeStr.split(':').map(Number)
              if (parts.length === 2 && !parts.some(isNaN)) {
                let nh = parts[0]
                let nm = parts[1] + 1
                if (nm >= 60) { nm = 0; nh = (nh + 1) % 24 }
                const pad = n => String(n).padStart(2, '0')
                const minTimeStr = `${pad(nh)}:${pad(nm)}`
                return {
                  selectableRange: `${minTimeStr}:00 - 23:59:59`
                }
              }
            }
          }
        }
      }
      return {
        selectableRange: '00:00:00 - 23:59:59'
      }
    },
    historyReplenishmentHintText() {
      /* 按照需求暂时注释：弹窗内不再弹出历史补录黄条提示
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName)) return ''
      if (!this.form.outboundDate) return ''
      let selCard = null
      if (this.form.orderId) {
        selCard = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
      } else if ((this.vipCardOptions || []).length > 0) {
        selCard = this.vipCardOptions[0]
      }
      if (!selCard) {
        selCard = { cardName: this.form.cardName, serviceFeeStartDate: null, createTime: new Date() }
      }
      const applyTime = String(this.form.outboundDate).replace('T', ' ')
      const winStartStr = this.getCardWindowStartStr(selCard)
      const applyFmt = this.form.cardName === '尊贵卡A' ? applyTime.slice(0, 10) : applyTime.slice(0, 16)
      if (winStartStr && applyTime.slice(0, 10) < winStartStr) {
        if (this.form.cardName === '尊贵卡A') {
          return `申请时间（${applyFmt}）属于过去的服务年度（早于本年度起点 ${winStartStr}），属于跨年历史补录。保存后【不会扣除】本年度的剩余可领取数量。`
        }
        return `申请时间（${applyFmt}）属于过去的服务年度（早于本年度起点 ${winStartStr}），属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
      }
      if (selCard && selCard.actualUpdateTime && this.form.cardName !== '尊贵卡A') {
        const actualTime = String(selCard.actualUpdateTime).replace('T', ' ')
        if (applyTime < actualTime) {
          const actualFmt = actualTime.slice(0, 16)
          const wordUnit = this.form.cardName === '尊贵卡B' ? '应该剩余额度' : '应该剩余'
          return `申请时间（${applyFmt}）早于实际剩余设置时间（${actualFmt}），属于本年度历史补录。保存后【只扣除${wordUnit}】，【不扣除实际剩余】。`
        }
      }
      */
      return ''
    }
  },
  mounted() {
    this.loadList()
    this.loadCurrentUser()
    this.loadSalesmen()
    this.loadAdmins()
    this.loadBufferConfig()
    this.loadTrialTypes()
    this.loadGiftTypes()
    this.loadOutboundTypes()
    this.loadCustomers()
    // 监听出库管理改欠款事件，自动刷新本列表
    this._outboundDebtHandler = () => this.loadList()
    window.addEventListener('outbound-debt-changed', this._outboundDebtHandler)
  },
  beforeDestroy() {
    if (this._outboundDebtHandler) {
      window.removeEventListener('outbound-debt-changed', this._outboundDebtHandler)
    }
    if (this.smsTimer) {
      clearInterval(this.smsTimer)
      this.smsTimer = null
    }
  },
  watch: {
    'embeddedCustomer.id': {
      handler(newId) {
        if (newId) this.loadList()
      },
      immediate: true
    },
    'form.customerName'() {
      this.refreshVipProductOpts()
      this.recheckTrialDetails()
      if (this.isTrialOutbound && this.currentTrialType && this.currentTrialType.needVerification === 1 && !this.form.verifyPhone) {
        const phone = this.customerPhoneMap && this.form.customerName ? (this.customerPhoneMap[this.form.customerName.trim()] || '').trim() : ''
        if (phone && /^1[3-9]\d{9}$/.test(phone) && !phone.startsWith('0000')) {
          this.form.verifyPhone = phone
        }
      }
      if (this.isGiftOutbound) {
        this.checkCustomerGiftEligibility()
      }
    },
    'form.cardName'(neu, old) {
      if (this.isOpeningEdit) return
      // 切换卡类型时清掉具体 orderId，让接口刷出后选首张
      if (neu !== old) this.form.orderId = null
      if (neu === '送存货') {
        if (!this.form.stockType) {
          this.$set(this.form, 'stockType', '普通存货')
        }
      } else {
        this.$set(this.form, 'stockType', '')
      }
      if (neu === '试用' || neu === '产品试用') {
        if (!this.form.applicableTypeId && this.trialTypeOptions.length > 0) {
          this.onTrialTypeChange(this.trialTypeOptions[0].id)
        }
      } else if (neu === '礼品') {
        this.form.applicableTypeId = null
        this.form.applicableTypeName = ''
        this.form.details = [{ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false }]
        this.checkCustomerGiftEligibility()
      } else {
        this.form.applicableTypeId = null
        this.form.applicableTypeName = ''
      }
      this.refreshVipProductOpts()
      this.recheckTrialDetails()
      // 出库类型变 → 业务员/审核员下拉按新类型重新拉（仅拥有该类型权限的）
      this.loadSalesmen(neu)
      this.loadAdmins(neu)
      this.syncOutboundDateTime()
    },
    'form.stockType'(neu, old) {
      if (this.isOpeningEdit) return
      if (this.form.cardName === '送存货') {
        if (neu !== old && old) {
          this.form.details = [{ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false }]
        }
        this.refreshVipProductOpts()
      }
    },
    'form.orderId'() {
      // A/C 类型：产品下拉是按 orderId 维度的，orderId 变（含异步首次选中）就重刷
      if (['尊贵卡A', '尊贵卡C'].includes(this.form.cardName)) this.refreshVipProductOpts()
    },
    formDatePart() { this.syncOutboundDateTime() },
    formTimePart() { this.syncOutboundDateTime() }
  },
  methods: {
    getCardWindowStartStr(card) {
      if (!card) return null
      const startDateStr = card.serviceFeeStartDate || card.createTime
      if (!startDateStr) return null
      const feeDateStr = String(startDateStr).slice(0, 10)
      const parts = feeDateStr.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return null
      const startDate = new Date(parts[0], parts[1] - 1, parts[2])
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const pad = n => String(n).padStart(2, '0')
      if (today < startDate) {
        return `${parts[0]}-${pad(parts[1])}-${pad(parts[2])}`
      }
      let winStart = new Date(startDate)
      while (true) {
        let nextStart = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate())
        if (today >= nextStart) {
          winStart = nextStart
        } else {
          break
        }
      }
      return `${winStart.getFullYear()}-${pad(winStart.getMonth() + 1)}-${pad(winStart.getDate())}`
    },
    getSelectedCardServiceYearWindow() {
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName)) return ''
      const list = this.vipCardOptions || []
      const sel = list.find(c => c.id === this.form.orderId) || list[0]
      if (!sel || !sel.serviceFeeStartDate) return '-'
      const parts = String(sel.serviceFeeStartDate).slice(0, 10).split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return '-'
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      let winStart = new Date(parts[0], parts[1] - 1, parts[2])
      const formatDate = (d) => {
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      if (today < winStart) {
        let winEnd = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate() - 1)
        return `${formatDate(winStart)} ~ ${formatDate(winEnd)}`
      }
      while (true) {
        let nextStart = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate())
        if (today >= nextStart) {
          winStart = nextStart
        } else {
          break
        }
      }
      let winEnd = new Date(winStart.getFullYear() + 1, winStart.getMonth(), winStart.getDate() - 1)
      return `${formatDate(winStart)} ~ ${formatDate(winEnd)}`
    },
    syncOutboundDateTime() {
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName) && this.formDatePart) {
        const bounds = this.getCardBoundaryDates
        if (bounds && bounds.winStartStr && bounds.winEndStr && bounds.winEndStr >= bounds.winStartStr) {
          const replenish = this.form.replenishType || 'normal'
          const dStr = this.formDatePart
          let invalid = false
          let targetD = dStr
          if (replenish === 'cross_year') {
            if (dStr < bounds.contractStartStr || dStr >= bounds.winStartStr) {
              invalid = true
              targetD = bounds.winStartStr > bounds.contractStartStr ? bounds.winStartStr : bounds.contractStartStr
            }
          } else if (replenish === 'in_year') {
            if (dStr < bounds.winStartStr || dStr > bounds.inYearUpperStr) {
              invalid = true
              targetD = bounds.winStartStr
            }
          } else {
            if (dStr < bounds.normalMinDate || dStr > bounds.winEndStr) {
              invalid = true
              targetD = bounds.normalMinDate
            }
          }
          if (invalid) {
            this.formDatePart = targetD
            return
          }
        }
      }
      if (this.formDatePart) {
        if (['尊贵卡B', '尊贵卡C'].includes(this.form.cardName)) {
          let t = this.formTimePart || '00:00'
          if ((this.form.replenishType || 'normal') === 'normal') {
            const bounds = this.getCardBoundaryDates
            const actStr = bounds.actualUpdateStr
            if (actStr && this.formDatePart === actStr) {
              let selCard = null
              if (this.form.orderId) {
                selCard = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
              } else if ((this.vipCardOptions || []).length > 0) {
                selCard = this.vipCardOptions[0]
              }
              const actTime = selCard ? (selCard.actualUpdateTime || selCard.orderActualUpdateTime) : null
              if (actTime) {
                const rawTimeStr = String(actTime).replace('T', ' ').slice(11, 16)
                if (rawTimeStr && rawTimeStr.length === 5) {
                  const parts = rawTimeStr.split(':').map(Number)
                  if (parts.length === 2 && !parts.some(isNaN)) {
                    let nh = parts[0]
                    let nm = parts[1] + 1
                    if (nm >= 60) { nm = 0; nh = (nh + 1) % 24 }
                    const pad = n => String(n).padStart(2, '0')
                    const minTimeStr = `${pad(nh)}:${pad(nm)}`
                    if (t.slice(0, 5) < minTimeStr) {
                      t = minTimeStr
                      this.formTimePart = minTimeStr
                    }
                  }
                }
              }
            }
          }
          const timeStr = t.slice(0, 5)
          this.form.outboundDate = `${this.formDatePart} ${timeStr}`
        } else {
          this.form.outboundDate = `${this.formDatePart} 00:00`
        }
      } else {
        this.form.outboundDate = ''
      }
    },
    setFormToNow() {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      this.formDatePart = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
      this.formTimePart = `${pad(d.getHours())}:${pad(d.getMinutes())}`
      this.syncOutboundDateTime()
    },
    initOutboundDateParts(datetimeStr) {
      if (!datetimeStr) {
        this.setFormToNow()
        return
      }
      const s = String(datetimeStr).replace('T', ' ')
      if (s.length >= 10) {
        this.formDatePart = s.slice(0, 10)
        if (s.length >= 16) {
          this.formTimePart = s.slice(11, 16)
        } else {
          this.formTimePart = '00:00'
        }
      } else {
        this.setFormToNow()
      }
      this.syncOutboundDateTime()
    },
    formatDateMinute(v, row) {
      if (!v && (!row || !row.createTime)) return '-'
      let s = String(v || '').replace('T', ' ')
      if (row && row.cardName === '尊贵卡A') {
        return s.slice(0, 10) || '-'
      }
      if (s.length === 10 && row && row.createTime) {
        const ct = String(row.createTime).replace('T', ' ')
        if (ct.length >= 16) {
          s = s + ' ' + ct.slice(11, 16)
        }
      }
      return s.length >= 16 ? s.slice(0, 16) : (s || '-')
    },
    formatFullTime(v) {
      if (!v) return '-'
      const s = String(v).replace('T', ' ')
      return s.length >= 16 ? s.slice(0, 16) : (s || '-')
    },
    isHistoryReplenishment(row) {
      if (!row) return false
      const cardName = String(row.cardName || row.outboundType || '').trim()
      if (!cardName.includes('尊贵卡') && !['A', 'B', 'C'].some(k => cardName.toUpperCase().includes(k))) return false
      if (row.isHistoryReplenishment == true || row.isHistoryReplenishment === 'true' || row.isHistoryReplenishment === 1) return true
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      if (!appTime) return false
      const appStr = String(appTime).replace('T', ' ')
      const winStartStr = this.getCardWindowStartStr(row)
      if (winStartStr && appStr.slice(0, 10) < winStartStr) return true
      if (actualTime && !cardName.toUpperCase().includes('A') && appStr <= String(actualTime).replace('T', ' ')) return true
      return false
    },
    historyReplenishmentRemarkNote(row) {
      /* 按照需求暂时注释：展开行申请备注不自动拼接历史补录提示文本
      if (!row || !this.isHistoryReplenishment(row)) return ''
      const cardName = String(row.cardName || row.outboundType || '').trim()
      const appTime = row.applicationTime || row.outboundDate || row.createTime
      const actualTime = row.orderActualUpdateTime || row.actualUpdateTime
      const isCardA = cardName.toUpperCase().includes('A')
      const winStartStr = this.getCardWindowStartStr(row)
      const appStr = String(appTime || '').replace('T', ' ')

      // 1. 尊贵卡A（含 尊贵卡A, 尊贵卡A1, 尊贵卡A2 等）
      if (isCardA) {
        const applyFmt = String(appTime || '').slice(0, 10)
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的剩余可领取数量。`
      }

      // 2. 尊贵卡B 与 尊贵卡C（含 尊贵卡B1, 尊贵卡C2 等）
      const applyFmt = this.formatFullTime(appTime)
      if (winStartStr && appStr.slice(0, 10) < winStartStr) {
        return `申请时间（${applyFmt}）属于过去的服务年度${winStartStr ? '（早于本年度起点 ' + winStartStr + '）' : ''}，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
      }
      return `申请时间（${applyFmt}）属于过去的服务年度，属于跨年历史补录。保存后【不会扣除】本年度的应该剩余或实际剩余（或额度）。`
      */
      return ''
    },
    // 加载服务费休眠缓冲期配置
    loadBufferConfig() {
      return axios.get('/system-config/get').then(res => {
        const cfg = res.data || {}
        const val = parseInt(cfg.service_fee_dormant_buffer_value, 10)
        const unit = cfg.service_fee_dormant_buffer_unit || 'day'
        this.bufferValue = isNaN(val) ? 10 : val
        this.bufferUnit = unit
      }).catch(() => {
        this.bufferValue = 10
        this.bufferUnit = 'day'
      })
    },
    // 计算缓冲天数
    calcBufferDays() {
      const val = this.bufferValue || 0
      const unit = this.bufferUnit || 'day'
      if (unit === 'month') return val * 30  // 月转天
      return val  // 天
    },
    // 「超级管理员XXX代为审核」前缀切割：让前缀单独红色加粗
    proxyPrefix(t) { const m = String(t == null ? '' : t).match(/^【超级管理员.+?代为审核】/); return m ? m[0] : '' },
    proxyBody(t) { return String(t == null ? '' : t).replace(/^【超级管理员.+?代为审核】/, '') },
    // 提取/推导单据的【提交模式】文本（跨年度补录 / 本年度内补录 / 正常提交 / 本年度提交）
    getReplenishTypeLabel(row) {
      if (!row) return '-'
      const cardName = String(row.cardName || row.outboundType || '').trim()
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(cardName)) return '-'
      
      const repType = row.replenishType || row.replenishMode
      if (repType === 'cross_year') return '跨年度补录'
      if (repType === 'in_year') return '本年度内补录'
      if (repType === 'normal') return cardName === '尊贵卡A' ? '本年度提交' : '正常提交'

      // 若数据库单据未存 replenishType，按历史补录规则自动计算展示：
      if (this.isHistoryReplenishment(row)) {
        const appTime = row.applicationTime || row.outboundDate || row.createTime
        const appStr = String(appTime || '').replace('T', ' ').slice(0, 10)
        const winStartStr = this.getCardWindowStartStr(row)
        if (winStartStr && appStr < winStartStr) {
          return '跨年度补录'
        } else if (['尊贵卡B', '尊贵卡C'].includes(cardName)) {
          return '本年度内补录'
        }
      }
      return cardName === '尊贵卡A' ? '本年度提交' : '正常提交'
    },
    // 根据【提交模式】匹配 Tag 标签颜色
    getReplenishTagType(row) {
      const label = this.getReplenishTypeLabel(row)
      if (label === '跨年度补录') return 'danger'
      if (label === '本年度内补录') return 'warning'
      if (label === '本年度提交' || label === '正常提交') return 'success'
      return 'info'
    },
    loadOutboundTypes() {
      axios.get('/outbound-type/list').then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.outboundTypes = list.filter(t => t.enabled !== 0)
      }).catch(() => { this.outboundTypes = [] })
    },
    isGiftOutboundType(typeName, row) {
      if (!typeName) return false
      const str = String(typeName).trim()
      if (str === '礼品' || str.startsWith('礼品·')) return true
      // 1. 动态匹配已配置的出库类型（categoryId === 1 为礼品大类）
      if (this.outboundTypes && this.outboundTypes.length) {
        const match = this.outboundTypes.find(t => t && t.name === str)
        if (match && Number(match.categoryId) === 1) return true
      }
      // 2. 检查 row 的 applicableTypeName / applicableTypeId 是否在礼品类型列表中
      if (row && (row.applicableTypeId || row.applicableTypeName)) {
        if (this.giftTypeOptions && this.giftTypeOptions.length) {
          if (this.giftTypeOptions.some(g => g.id === row.applicableTypeId || g.name === row.applicableTypeName)) {
            return true
          }
        }
      }
      // 3. 兜底内置常见礼品出库类型名称
      if (['损耗', '试喝', '赠送', '过期'].includes(str)) return true
      return false
    },
    // 类型 + 卡序号：仅尊贵卡 A/B/C 带序号（"尊贵卡A2"）；试用类型展示具体试用类型；礼品类展示礼品及具体类型；其它类别原样返回
    vipCardLabel(category, cardSeq, applicableTypeName) {
      let stockType = null
      let rawRow = null
      if (category && typeof category === 'object') {
        rawRow = category
        stockType = category.stockType
        applicableTypeName = category.applicableTypeName
        cardSeq = category.cardSeq
        category = category.cardName || category.outboundType || category.category
      }
      if (!category) return ''
      if (category === '送存货') {
        if (stockType === '品鉴存货' || stockType === '试用存货' || applicableTypeName) {
          return (applicableTypeName && String(applicableTypeName).trim())
            ? ('品鉴存货·' + String(applicableTypeName).trim())
            : (stockType || '品鉴存货')
        }
        return stockType || '普通存货'
      }
      if (category === '产品试用' || category === '试用') {
        return (applicableTypeName && String(applicableTypeName).trim()) ? String(applicableTypeName).trim() : '试用'
      }
      // 礼品大类或礼品分类下的动态出库类型（损耗、试喝、赠送、过期或后台新增类型）
      if (this.isGiftOutboundType(category, rawRow)) {
        const subType = (applicableTypeName && String(applicableTypeName).trim()) || ''
        const cleanName = String(category).replace(/^礼品[·\s]*/, '')
        if (!cleanName || cleanName === '礼品') {
          return subType ? `礼品·${subType}` : '礼品'
        }
        return subType ? `礼品·${subType}·${cleanName}` : `礼品·${cleanName}`
      }
      const isVip = category === '尊贵卡A' || category === '尊贵卡B' || category === '尊贵卡C'
      if (!isVip) return category
      if (cardSeq == null || cardSeq === '') return category
      return category + cardSeq
    },
    loadList() {
      this.loadBufferConfig().then(() => {
        const params = { page: this.currentPage, size: this.pageSize }
        // 嵌入模式：锁定该客户，仍可叠加状态搜索
        if (this.embedded) params.customerId = this.embeddedCustomer.id
        if (!this.embedded && this.searchForm.customerName) params.customerName = this.searchForm.customerName
        if (this.searchForm.outboundType) params.outboundType = this.searchForm.outboundType
        if (this.searchForm.stockType) params.stockType = this.searchForm.stockType
        if (this.searchForm.giftTypeId !== '' && this.searchForm.giftTypeId !== null) params.giftTypeId = this.searchForm.giftTypeId
        if (this.searchForm.status !== '' && this.searchForm.status !== null) params.status = this.searchForm.status
        axios.get('/outbound/vip-card-page', { params }).then(res => {
          this.orderList = (res.data && res.data.records) || []
          this.total = (res.data && res.data.total) || 0
          // 客户详情内嵌时也不默认展开，保持收起
          this.expandedKeys = []
        })
      })
    },
    handleSearch() { this.currentPage = 1; this.loadList() },
    resetSearch() { this.searchForm = { customerName: '', outboundType: '', stockType: '', giftTypeId: '', status: '' }; this.handleSearch() },
    indexMethod(index) {
      return this.total - ((this.currentPage - 1) * this.pageSize + index)
    },
    openDetail(row) {
      this.detail = row
      this.detailVisible = true
    },
    getCurrentDateTimeStr() {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      const YYYY = d.getFullYear()
      const MM = pad(d.getMonth() + 1)
      const DD = pad(d.getDate())
      const hh = pad(d.getHours())
      const mm = pad(d.getMinutes())
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}`
    },
    emptyForm() {
      return {
        id: null, customerId: null, customerName: '', cardName: '', orderId: null,
        stockType: '普通存货',
        applicableTypeId: null,
        applicableTypeName: '',
        verificationType: 3,
        verifyPhone: '',
        smsCode: '',
        attachmentUrl: '',
        attachmentName: '',
        replenishType: 'normal',
        reason: '', remark: '',
        outboundDate: this.getCurrentDateTimeStr(),
        salesmanId: null,
        approverId: null,
        details: [{ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false }],
        customerSignature: '', employeeSignature: '', signature: '', images: ''
      }
    },
    onReplenishTypeChange(val) {
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName)) return
      const bounds = this.getCardBoundaryDates
      const pad = n => String(n).padStart(2, '0')
      const curDateStr = this.formDatePart || ''

      let targetDateStr = curDateStr
      if (val === 'cross_year') {
        if (!curDateStr || curDateStr < bounds.contractStartStr || curDateStr >= bounds.winStartStr) {
          const parts = bounds.winStartStr.split('-').map(Number)
          if (parts.length === 3 && !parts.some(isNaN)) {
            const prevDay = new Date(parts[0], parts[1] - 1, parts[2] - 1)
            targetDateStr = `${prevDay.getFullYear()}-${pad(prevDay.getMonth() + 1)}-${pad(prevDay.getDate())}`
            if (targetDateStr < bounds.contractStartStr) targetDateStr = bounds.contractStartStr
          } else {
            targetDateStr = bounds.contractStartStr
          }
        }
      } else if (val === 'in_year') {
        if (!curDateStr || curDateStr < bounds.winStartStr || curDateStr > bounds.inYearUpperStr) {
          targetDateStr = bounds.winStartStr
        }
      } else {
        const minNormalStr = bounds.normalMinDate
        if (!curDateStr || curDateStr < minNormalStr || curDateStr > bounds.winEndStr) {
          const todayStr = `${new Date().getFullYear()}-${pad(new Date().getMonth() + 1)}-${pad(new Date().getDate())}`
          if (todayStr >= minNormalStr && todayStr <= bounds.winEndStr) {
            targetDateStr = todayStr
          } else {
            targetDateStr = minNormalStr
          }
        }
      }
      this.formDatePart = targetDateStr
      this.syncOutboundDateTime()
    },
    openEdit(row) {
      if (!row) {
        this.form = this.emptyForm()
        // 嵌入模式：新建锁定为当前客户
        if (this.embedded) {
          const c = this.embeddedCustomer || {}
          this.form.customerId = c.id
          this.form.customerName = c.name || ''
          // 业务员下拉强制锁定为客户当前负责人姓名
          if (c.responsiblePerson) {
            const resp = String(c.responsiblePerson).trim()
            const matched = (this.salesmanOptions || []).find(u => (u.name && u.name.trim() === resp) || (u.username && u.username.trim() === resp))
            if (matched) {
              this.form.salesmanId = matched.id
            } else {
              axios.get('/user/list').then(uRes => {
                const allUsers = (uRes.data && (uRes.data.list || uRes.data)) || []
                const hit = allUsers.find(u => (u.name && u.name.trim() === resp) || (u.username && u.username.trim() === resp))
                if (hit) {
                  if (!this.salesmanOptions.find(u => Number(u.id) === Number(hit.id))) {
                    this.salesmanOptions.push(hit)
                  }
                  this.form.salesmanId = hit.id
                }
              }).catch(() => {})
            }
          }
        }
        this.cardOptions = [
          { label: '礼品', value: '礼品' },
          { label: '产品试用', value: '试用' },
          { label: '新出库', value: '新出库' }
        ]
        this.editVisible = true
        this.initOutboundDateParts('')
        // 打开弹窗后局域拉一次该客户销售订单 category 加到"类型"下拉
        this.$nextTick(() => this.lookupCustomerInfo())
        return
      }
      // 按钮已用 disabled 控制；服务端兜底校验（防绕过）
      if (!this.canEditRow(row)) {
        this.$message.warning('当前状态不允许修改')
        return
      }
      this.isOpeningEdit = true
      const rawAppDate = row.applicationTime || row.outboundDate || row.createTime
      const isInOpt = ['送存货', '尊贵卡A', '尊贵卡C'].includes(row.cardName)
      let repType = 'normal'
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(row.cardName) && this.isHistoryReplenishment(row)) {
        const appTime = row.applicationTime || row.outboundDate || row.createTime
        const appStr = String(appTime || '').replace('T', ' ').slice(0, 10)
        const winStartStr = this.getCardWindowStartStr(row)
        if (winStartStr && appStr < winStartStr) {
          repType = 'cross_year'
        } else if (['尊贵卡B', '尊贵卡C'].includes(row.cardName)) {
          repType = 'in_year'
        }
      }
      const origDetails = row.details || []
      const origQty = origDetails.reduce((sum, d) => sum + (Number(d.quantity) || 0), 0)
      const origAmt = row.totalAmount != null && Number(row.totalAmount) > 0 ? Number(row.totalAmount)
        : origDetails.reduce((sum, d) => sum + ((Number(d.price || d.unitPrice || 0)) * (Number(d.quantity) || 0)), 0)

      this.form = {
        id: row.id,
        _origStatus: row.status,
        _origQty: origQty,
        _origAmt: origAmt,
        actualUpdateTime: row.actualUpdateTime || null,
        applicationTime: row.applicationTime || row.createTime || row.outboundDate,
        customerId: row.customerId,
        customerName: row.customerName || '',
        cardName: row.cardName || '',
        stockType: row.stockType || (row.cardName === '送存货' ? '普通存货' : ''),
        orderId: row.orderId || null,
        applicableTypeId: row.applicableTypeId || null,
        applicableTypeName: row.applicableTypeName || '',
        verificationType: row.verificationType != null ? row.verificationType : 3,
        verifyPhone: row.verifyPhone || '',
        smsCode: '',
        attachmentUrl: row.attachmentUrl || '',
        attachmentName: row.attachmentUrl ? '凭证附件' : '',
        replenishType: repType,
        reason: row.reason || '',
        remark: row.remark || '',
        outboundDate: rawAppDate ? String(rawAppDate).replace('T', ' ') : this.getCurrentDateTimeStr(),
        salesmanId: row.userId || null,
        approverId: row.approverId || null,
        details: (row.details || []).map(d => {
          const pid = d.productId
          const pName = d.productName || ''
          const optSuffix = isInOpt ? '_in' : '_out'
          return {
            productId: pid,
            productName: pName,
            quantity: d.quantity,
            price: d.price != null ? d.price : (d.unitPrice != null ? d.unitPrice : 0),
            productOptKey: pid ? (pid + optSuffix) : null,
            tipMessage: '',
            statusType: 'normal',
            canApply: true,
            limitExceeded: false,
            isUnlocked: false
          }
        }),
        customerSignature: row.customerSignature || '',
        employeeSignature: row.employeeSignature || '',
        signature: row.signature || '',
        images: row.images || ''
      }
      if (this.form.details.length === 0) this.form.details.push({ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false })
      this.initOutboundDateParts(rawAppDate)
      this.editVisible = true
      this.$nextTick(() => {
        this.lookupCustomerInfo()
        this.refreshVipProductOpts()
        if (this.isGiftOutbound) {
          this.checkCustomerGiftEligibility()
        }
        if (this.isTrialOutbound) {
          this.recheckTrialDetails()
        }
        setTimeout(() => { this.isOpeningEdit = false }, 300)
      })
    },
    // 剥掉下拉里拼的「（剩余存货 N）」「（剩余可领取 N）」后缀，只留裸产品名
    stripStockSuffix(name) {
      return String(name || '').replace(/（.*）\s*$/, '').trim()
    },
    onDetailProductChange(d) {
      const p = (this.productOpts || []).find(x => x.optKey === d.productOptKey)
      if (p) {
        d.productId = p.id
        // 只存裸产品名（送存货/尊贵卡的"（剩余…）"后缀都剥掉）
        d.productName = this.stripStockSuffix(p.name)
        if (p.price != null) d.price = p.price
      } else {
        d.productId = null
        d.productName = ''
      }
      if (this.isTrialOutbound) {
        this.checkProductTrialLimit(d)
      }
    },
    lookupCustomerInfo() {
      const allBase = [
        { label: '尊贵卡A', value: '尊贵卡A' },
        { label: '尊贵卡B', value: '尊贵卡B' },
        { label: '尊贵卡C', value: '尊贵卡C' },
        { label: '送存货', value: '送存货' },
        { label: '礼品', value: '礼品' },
        { label: '产品试用', value: '试用' },
        { label: '新出库', value: '新出库' }
      ]
      const name = (this.form.customerName || '').trim()
      const custId = this.form.customerId || (this.embedded && this.embeddedCustomer ? this.embeddedCustomer.id : null)
      if (!name && !custId) {
        if (!this.form.id) {
          this.cardOptions = [
            { label: '礼品', value: '礼品' },
            { label: '产品试用', value: '试用' },
            { label: '新出库', value: '新出库' }
          ]
        } else {
          this.cardOptions = allBase
        }
        return
      }
      const params = { page: 1, size: 100 }
      if (custId) params.customerId = custId
      if (name) params.customerName = name
      axios.get('/order/page', { params }).then(res => {
        const records = (res.data && res.data.records) || []
        const custCategories = new Set(records.map(o => o.category).filter(Boolean))

        let targetList = []
        if (!this.form.id) {
          // 【仅新建提货申请】：送存货、尊贵卡A/B/C 销售订单里有才展示，没有不展示
          const orderDependent = ['尊贵卡A', '尊贵卡B', '尊贵卡C', '送存货']
          const permanent = [
            { label: '礼品', value: '礼品' },
            { label: '产品试用', value: '试用' },
            { label: '新出库', value: '新出库' }
          ]
          orderDependent.forEach(cName => {
            if (custCategories.has(cName)) {
              targetList.push({ label: cName, value: cName })
            }
          })
          targetList.push(...permanent)
          // 额外自定义分类（如果有）
          const standardSet = new Set([...orderDependent, '礼品', '试用', '产品试用', '新出库'])
          records.forEach(o => {
            if (o.category && !standardSet.has(o.category) && !targetList.find(t => t.value === o.category)) {
              targetList.push({ label: o.category, value: o.category })
            }
          })
        } else {
          // 修改已有申请：保持全量，且确保当前单据的 cardName 回显
          const baseValues = new Set(allBase.map(b => b.value))
          const extra = Array.from(new Set(
            records.map(o => o.category).filter(c => c && !baseValues.has(c))
          )).map(c => ({ label: c, value: c }))
          if (this.form.cardName && !baseValues.has(this.form.cardName) && !extra.find(o => o.value === this.form.cardName)) {
            extra.push({ label: this.form.cardName, value: this.form.cardName })
          }
          targetList = extra.length ? [...allBase, ...extra] : allBase
        }

        const curKeys = (this.cardOptions || []).map(o => o.value).join(',')
        const targetKeys = targetList.map(o => o.value).join(',')
        if (curKeys !== targetKeys) {
          this.cardOptions = targetList
        }
      }).catch(() => {})
    },
    refreshVipDialogExtra() {
      const name = (this.form.customerName || '').trim()
      const card = this.form.cardName
      this.vipDialogQuota = ''
      this.vipDialogActualQuota = ''
      this.vipDialogServiceTerm = ''
      this.vipDialogRemainPickup = ''
      this.vipCardOptions = []
      if (!name) return
      if (!['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(card)) return
      const targetOrderId = this.form.orderId // 锁定该笔提货绑定的具体销售订单 ID
      // 先解析 customerId，再拉该客户该类卡列表
      const apply = (cid) => {
        if (!cid) return
        axios.get('/order/customer-vip-cards', { params: { customerId: cid, category: card } }).then(res => {
          const list = res.data || []
          this.vipCardOptions = list
          if (!list.length) return
          // 优先锁定本笔申请所绑定的特定销售订单；未绑定或找不到时才自动回落第一张
          const exist = list.find(c => c.id === targetOrderId)
          if (exist) {
            this.form.orderId = exist.id
          } else if (!this.form.orderId) {
            this.form.orderId = list[0].id
          }
          this.applyVipCardExtra()
        }).catch(() => { this.vipCardOptions = [] })
      }
      if (this.form.customerId) {
        apply(this.form.customerId)
      } else {
        // 编辑回显或新建无 customerId 时按姓名查
        axios.get('/customer/list').then(r => {
          const hit = (r.data || []).find(c => c.name === name)
          apply(hit ? hit.id : null)
        }).catch(() => apply(null))
      }
    },
    // 把选中的卡的额度/服务期限填到展示字段
    applyVipCardExtra() {
      const card = this.form.cardName
      const sel = this.vipCardOptions.find(c => c.id === this.form.orderId)
      if (!sel) { this.vipDialogQuota = ''; this.vipDialogActualQuota = ''; this.vipDialogServiceTerm = ''; this.vipDialogRemainPickup = ''; return }
      if (card === '尊贵卡B') {
        this.vipDialogQuota = sel.remainingAmount != null ? String(sel.remainingAmount) : '0'
        this.vipDialogActualQuota = sel.actualQuotaRemaining != null ? String(sel.actualQuotaRemaining) : '0'
      } else if (card === '尊贵卡A' || card === '尊贵卡C') {
        this.vipDialogRemainPickup = sel.remainingPickupTotal != null ? String(sel.remainingPickupTotal) : '0'
      }
      if (card === '尊贵卡B' || card === '尊贵卡C') {
        this.serviceFeeOverdue = false; this.serviceFeeWarning = ''
        this.loadBufferConfig().then(() => {
          this.vipDialogServiceTerm = this.computeServiceDueDate({
            serviceFeeStartDate: sel.serviceFeeStartDate,
            freeServiceMonths: sel.freeServiceMonths,
            serviceFeePaidYears: sel.serviceFeePaidYears,
            expiryWarningDays: sel.expiryWarningDays,
            _setOverdue: (o, w) => { this.serviceFeeOverdue = o; this.serviceFeeWarning = w }
          }) || '—'
        })
      } else {
        this.serviceFeeOverdue = false; this.serviceFeeWarning = ''
      }
    },
    onVipCardChange() {
      this.applyVipCardExtra()
      // 选不同卡 → A/C 类型时要按新订单的明细重刷产品下拉
      if (['尊贵卡A', '尊贵卡C'].includes(this.form.cardName)) this.refreshVipProductOpts()
    },
    // 安全加「尊贵卡-」前缀：已带前缀就不重复加（避免「尊贵卡-尊贵卡-X」）
    vipPrefix(name) {
      const n = String(name || '').trim()
      return n.startsWith('尊贵卡-') ? n : ('尊贵卡-' + n)
    },
    refreshVipProductOpts() {
      const name = (this.form.customerName || '').trim()
      const card = this.form.cardName
      // 同步拉销售订单的剩余额度 / 服务期限
      this.refreshVipDialogExtra()
      if (!card || !name) { this.productOpts = []; return }
      const finalize = (opts) => {
        const list = opts || []
        // 如果表单已有选中的明细（编辑回显），解包并确保其在 list 中存在，防 0 存货过滤或加载延迟导致名称丢失或下拉显示为空
        (this.form.details || []).forEach(d => {
          if (d.productId) {
            const hit = list.find(p => p.id === d.productId)
            if (hit) {
              d.productOptKey = hit.optKey
              if (!d.productName) d.productName = this.stripStockSuffix(hit.name)
            } else if (d.productName) {
              const fallbackKey = d.productOptKey || (['送存货','尊贵卡A','尊贵卡C'].includes(card) ? (d.productId + '_in') : (d.productId + '_out'))
              d.productOptKey = fallbackKey
              list.unshift({
                optKey: fallbackKey,
                id: d.productId,
                name: d.productName
              })
            }
          }
        })
        this.productOpts = list
      }
      // 与 NormalOrder 统一：
      //   送存货=客户名下存货(无前缀)；礼品=礼品库；产品试用/新出库=公司产品(无前缀)；
      //   尊贵卡A/C=客户卡里产品(带前缀)；尊贵卡B=公司全部产品(带前缀)
      if (card === '送存货') {
        const stType = this.form.stockType || '普通存货'
        this.songCunHuoMinDate = ''
        axios.get('/order/page', { params: { page: 1, size: 100, customerName: name, category: '送存货', stockType: stType } }).then(res => {
          const records = (res.data && res.data.records) || []
          let minD = ''
          records.forEach(o => {
            const dt = String(o.saleDate || o.serviceFeeStartDate || o.createTime || '').slice(0, 10)
            if (dt && (!minD || dt < minD)) minD = dt
          })
          this.songCunHuoMinDate = minD
        }).catch(() => {})
        axios.get('/customer/list').then(res => {
          const hit = (res.data || []).find(c => c.name === name)
          if (!hit) { finalize([]); return }
          axios.get('/customer/' + hit.id + '/inventory', { params: { outboundType: '送存货', stockType: stType } }).then(r => {
            const items = (r.data && r.data.items) || []
            // 送存货：产品名后面拼 "（剩余存货 X）"，方便选品时一眼看到可提数量；剩余存货=0 的不显示
            finalize(items
              .filter(it => it.remainingStock == null || Number(it.remainingStock) > 0)
              .map(it => ({
                optKey: it.productId + '_in',
                id: it.productId,
                name: it.productName + (it.remainingStock != null ? `（剩余存货 ${it.remainingStock}）` : '')
              })))
          })
        })
      } else if (card === '礼品') {
        if (!this.form.applicableTypeId) {
          finalize([])
          return
        }
        const applyTypeId = this.form.applicableTypeId
        axios.get('/gift/list').then(res => {
          this.allGiftList = res.data || []
          const filtered = (this.allGiftList || []).filter(g => {
            if (g.giftTypeIds && g.giftTypeIds.length) {
              return g.giftTypeIds.includes(applyTypeId)
            }
            if (g.giftTypeList && g.giftTypeList.length) {
              return g.giftTypeList.some(t => t.giftTypeId === applyTypeId)
            }
            return false
          })
          finalize(filtered.map(p => ({ optKey: p.id + '_out', id: p.id, name: p.name })))
        }).catch(() => finalize([]))
      } else if (card === '尊贵卡A' || card === '尊贵卡C') {
        // 按选中的 orderId 拉该订单明细，标签里显示应该剩余与实际剩余
        if (!this.form.orderId) { finalize([]); return }
        axios.get('/order/' + this.form.orderId).then(res => {
          const ods = (res.data && res.data.details) || []
          // 已作废明细不显示
          finalize(ods.filter(d => {
            if (!d.productId) return false
            if (Number(d.voided) === 1) return false
            return true
          }).map(d => {
            const rem = d.remainingPickup != null ? d.remainingPickup : (d.stockLimit || d.quantity || 0)
            let labelSuffix = ''
            if (card === '尊贵卡C') {
              const shd = d.shouldRemaining != null ? d.shouldRemaining : rem
              const act = d.actualRemaining != null ? d.actualRemaining : 0
              labelSuffix = `（应该剩余 ${shd}，实际剩余 ${act}）`
              return {
                optKey: d.productId + '_in', id: d.productId,
                name: this.vipPrefix(d.productName) + labelSuffix,
                shouldRemaining: shd,
                actualRemaining: act,
                price: d.price != null ? d.price : 0,
                _limit: act
              }
            } else {
              labelSuffix = `（剩余可领取 ${rem}）`
              return {
                optKey: d.productId + '_in', id: d.productId,
                name: this.vipPrefix(d.productName) + labelSuffix,
                remainingPickup: rem,
                price: d.price != null ? d.price : 0,
                _limit: rem
              }
            }
          }))
        }).catch(() => finalize([]))
      } else if (card === '尊贵卡B') {
        axios.get('/product/list').then(res => {
          finalize((res.data || []).map(p => ({
            optKey: p.id + '_out',
            id: p.id,
            name: this.vipPrefix(p.name),
            price: p.price != null ? p.price : (p.unitPrice != null ? p.unitPrice : 0)
          })))
        })
      } else if (['试用', '产品试用'].includes(card)) {
        // 产品试用：如果选了试用类型，按适用类型过滤产品；否则展示全部
        axios.get('/product/list').then(res => {
          let prods = res.data || []
          if (this.form.applicableTypeId) {
            prods = prods.filter(p => p.applicableTypeId === this.form.applicableTypeId)
          }
          finalize(prods.map(p => ({ optKey: p.id + '_out', id: p.id, name: p.name })))
        })
      } else {
        // 新出库等其它类型：公司所有产品（无前缀）
        axios.get('/product/list').then(res => {
          finalize((res.data || []).map(p => ({ optKey: p.id + '_out', id: p.id, name: p.name })))
        })
      }
    },
    onSigSuccess(res, field) {
      if (res && res.success && res.url) {
        this.form[field] = res.url
        this.$message.success('上传成功')
      } else {
        this.$message.error((res && res.message) || '上传失败')
      }
    },
    onImagesSuccess(res) {
      if (res && res.success && res.url) {
        const list = this.splitUrls(this.form.images)
        list.push(res.url)
        this.form.images = list.join(',')
        this.$message.success('上传成功')
      } else {
        this.$message.error((res && res.message) || '上传失败')
      }
    },
    splitUrls(s) { return (s || '').split(',').filter(Boolean) },
    // 当前登录用户是否超管
    _isSuperAdmin() {
      const me = this.currentUser || (function () {
        try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} }
      })()
      return me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
    },
    submitEdit() {
      if (this.isAppTimeDisabled) {
        this.$message.error('当前卡片状态或所选模式下，申请时间不可选，无法提交申请！')
        return
      }
      const name = (this.form.customerName || '').trim()
      if (!name) { this.$message.warning('请输入客户姓名'); return }
      if (!this.form.cardName) { this.$message.warning('请选择类型'); return }
      if (!this.form.approverId) { this.$message.warning('请选择审核员'); return }
      if (!this.form.details.length || this.form.details.some(d => !d.productId || !(Number(d.quantity) > 0))) {
        this.$message.warning('请完善产品明细'); return
      }
      // 拦截提货申请时间早于基准起始日（尊贵卡A/B/C、送存货）
      const minDate = this.minOutboundDateStr
      if (minDate && this.form.outboundDate) {
        const appDateStr = String(this.form.outboundDate).slice(0, 10)
        if (appDateStr < minDate) {
          const typeLabel = ['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName) ? '合同服务起始日' : '销售/建单日期'
          this.$message.error(`申请时间（${appDateStr}）不能早于【${this.form.cardName}】${typeLabel}（${minDate}），无法提货`)
          return
        }
      }
      if (['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(this.form.cardName)) {
        const bounds = this.getCardBoundaryDates
        const replenish = this.form.replenishType || 'normal'
        const dStr = String(this.form.outboundDate || '').slice(0, 10)
        let invalid = false
        if (replenish === 'cross_year') {
          invalid = dStr < bounds.contractStartStr || dStr >= bounds.winStartStr
        } else if (replenish === 'in_year') {
          invalid = dStr < bounds.winStartStr || dStr > bounds.inYearUpperStr
        } else {
          invalid = dStr < bounds.normalMinDate || dStr > bounds.winEndStr
        }
        if (invalid) {
          const modeName = replenish === 'cross_year' ? '跨年度补录' : (replenish === 'in_year' ? '本年度内补录' : '正常提交')
          const minDateStr = replenish === 'cross_year' ? bounds.contractStartStr : (replenish === 'in_year' ? bounds.winStartStr : bounds.normalMinDate)
          const maxDateStr = replenish === 'cross_year' ? bounds.winStartStr : (replenish === 'in_year' ? bounds.inYearUpperStr : bounds.winEndStr)
          this.$message.error(`【${modeName}】所选申请日期（${dStr}）不在允许范围内（需在 ${minDateStr} 至 ${maxDateStr} 之间），无法提交！`)
          return
        }
      }
      // 尊贵卡A：校验提货数量不能大于剩余可领取数量（非历史补录场景）
      if (this.form.cardName === '尊贵卡A' && !this.historyReplenishmentHintText) {
        for (const d of this.form.details) {
          if (!d.productId) continue
          const pOpt = (this.productOpts || []).find(p => p.id === d.productId || p.optKey === d.productOptKey)
          if (pOpt && pOpt.remainingPickup != null) {
            const qty = Number(d.quantity) || 0
            const rem = Number(pOpt.remainingPickup)
            if (qty > rem) {
              this.$message.error(`提货申请失败！尊贵卡A 本年度【${d.productName}】额度已用完（剩余可领取 ${rem}，本次需 ${qty}）！如为跨年历史补录，请将【申请时间】选择为对应过去服务年度的日期。`)
              return
            }
          }
        }
      }
      // 尊贵卡B / 尊贵卡C 校验提货数量/金额不能超过可用限额
      const isCrossYear = this.form.replenishType === 'cross_year'
      const isInYear = this.form.replenishType === 'in_year'

      if (['尊贵卡B', '尊贵卡C'].includes(this.form.cardName) && !isCrossYear) {
        if (this.form.cardName === '尊贵卡C') {
          for (const d of this.form.details) {
            if (!d.productId) continue
            const pOpt = (this.productOpts || []).find(p => p.id === d.productId || p.optKey === d.productOptKey)
            if (pOpt) {
              const qty = Number(d.quantity) || 0
              if (isInYear) {
                // 本年度内补录：去减应该剩余数量，也是和应该剩余数量比较，和实际剩余没有任何关系
                const shd = pOpt.shouldRemaining != null ? Number(pOpt.shouldRemaining) : 9999
                if (qty > shd) {
                  this.$message.error(`提货申请失败！尊贵卡C【${d.productName}】本年度内补录数量（${qty}）不能大于应该剩余数量（${shd}）！`)
                  return
                }
              } else {
                // 正常提交：与实际剩余数量比较
                const act = pOpt.actualRemaining != null ? Number(pOpt.actualRemaining) : 9999
                if (qty > act) {
                  this.$message.error(`提货申请失败！产品【${d.productName}】提货数量（${qty}）不能大于实际剩余数量（${act}），请尽快缴纳服务费，缴纳后可正常提货！`)
                  return
                }
              }
            }
          }
        } else if (this.form.cardName === '尊贵卡B' && this.form.orderId) {
          const sel = (this.vipCardOptions || []).find(c => c.id === this.form.orderId)
          if (sel) {
            let applyAmount = 0
            for (const d of this.form.details) {
              const pOpt = (this.productOpts || []).find(p => p.id === d.productId || p.optKey === d.productOptKey)
              const price = pOpt && pOpt.price != null ? Number(pOpt.price) : 0
              applyAmount += price * (Number(d.quantity) || 0)
            }
            if (isInYear) {
              const shdQuota = sel.remainingAmount != null ? Number(sel.remainingAmount) : 999999
              if (applyAmount > shdQuota) {
                this.$message.error(`提货申请失败！尊贵卡B 本年度内补录金额（¥${applyAmount}）不能大于应该剩余额度（¥${shdQuota}）！`)
                return
              }
            } else {
              const actQuota = sel.actualQuotaRemaining != null ? Number(sel.actualQuotaRemaining) : 999999
              if (applyAmount > actQuota) {
                this.$message.error(`提货申请失败！本次提货金额（¥${applyAmount}）不能大于实际剩余额度（¥${actQuota}），请尽快缴纳服务费，缴纳后可正常提货！`)
                return
              }
            }
          }
        }
      }
      // 礼品相关校验
      if (this.isGiftOutbound) {
        if (!this.form.applicableTypeId) {
          this.$message.error(this.giftTypeOptions.length === 0 ? '该客户未在礼品名单中配置礼品分类权限，无法申请礼品提货' : '请选择礼品类型')
          return
        }
      }
      // 试用相关校验
      if (this.isTrialOutbound) {
        if (!this.form.applicableTypeId) {
          this.$message.error('请选择试用类型')
          return
        }
        for (const d of this.form.details) {
          if (!d.productId) continue
          if (d.canApply === false) {
            this.$alert(d.tipMessage || `产品【${d.productName || '该产品'}】已达试用上限，无法继续申请。需联系超级管理员在客户详情页解除限制。`, '无法提交试用申请', {
              confirmButtonText: '我知道了',
              type: 'error'
            })
            return
          }
        }
        const needVer = this.currentTrialType && this.currentTrialType.needVerification === 1
        if (needVer) {
          if (this.form.verificationType === 1) {
            if (!this.form.verifyPhone || !/^1\d{10}$/.test(this.form.verifyPhone.trim())) {
              this.$message.error('请输入正确的11位核验手机号码')
              return
            }
            if (!this.form.smsCode || this.form.smsCode.trim().length !== 6) {
              this.$message.error('请输入6位短信验证码')
              return
            }
            // 提交前核验短信验证码
            this.submitting = true
            axios.post('/sms/verify-trial-code', {
              phone: this.form.verifyPhone.trim(),
              code: this.form.smsCode.trim()
            }).then(verifyRes => {
              if (!verifyRes.data || !verifyRes.data.success) {
                this.submitting = false
                this.$message.error((verifyRes.data && verifyRes.data.message) || '验证码错误或已过期')
                return
              }
              this._doSubmitEdit()
            }).catch(err => {
              this.submitting = false
              this.$message.error('验证码核验失败：' + (err.message || '网络错误'))
            })
            return
          } else if (this.form.verificationType === 2) {
            if (!this.form.attachmentUrl) {
              this.$message.error('特殊通道必须上传凭证文件')
              return
            }
          }
        }
      }
      this._doSubmitEdit()
    },
    getQuantityMax(d) {
      if (!d || !d.productId) return 9999
      const pOpt = (this.productOpts || []).find(p => p.id === d.productId || p.optKey === d.productOptKey)
      if (!pOpt) return 9999
      if (this.form.cardName === '尊贵卡A') {
        if (this.form.replenishType === 'cross_year') {
          return 9999
        } else {
          return pOpt.remainingPickup != null ? Number(pOpt.remainingPickup) : 9999
        }
      }
      if (this.form.cardName === '尊贵卡C') {
        if (this.form.replenishType === 'cross_year') {
          return 9999
        } else if (this.form.replenishType === 'in_year') {
          return pOpt.shouldRemaining != null ? Number(pOpt.shouldRemaining) : 9999
        } else {
          return pOpt.actualRemaining != null ? Number(pOpt.actualRemaining) : 9999
        }
      }
      return 9999
    },
    // 判断休眠原因：免服务期内 vs 服务费已逾期
    _dormantReason(card) {
      if (!card) return '原因未知'
      const start = this.computeServiceFeeStart(card.serviceFeeStartDate, card.freeServiceMonths)
      if (!start) return '原因未知'
      const parts = start.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return '原因未知'
      const unlock = new Date(parts[0], parts[1] - 1, parts[2])
      const today = new Date(); today.setHours(0, 0, 0, 0)
      if (today < unlock) {
        // 业务调整：免服务期限内可正常提货，不返回任何休眠原因
        return null
      }
      return '服务费已逾期未缴'
    },
    _doSubmitEdit() {
      this.submitting = true
      const name = (this.form.customerName || '').trim()

      if (this.form.id) {
        // 修改
        const body = {
          customerId: this.form.customerId,
          outboundType: this.form.cardName,
          stockType: this.form.cardName === '送存货' ? (this.form.stockType || '普通存货') : null,
          applicableTypeId: this.form.applicableTypeId || null,
          applicableTypeName: this.form.applicableTypeName || null,
          verificationType: this.form.verificationType != null ? this.form.verificationType : 3,
          verifyPhone: this.form.verifyPhone || null,
          attachmentUrl: this.form.attachmentUrl || null,
          replenishType: this.form.replenishType,
          outboundDate: this.form.outboundDate || null,
          userId: this.form.salesmanId || null,
          approverId: this.form.approverId || null,
          orderId: this.form.orderId || null,
          reason: this.form.reason,
          remark: this.form.remark,
          customerSignature: this.form.customerSignature,
          employeeSignature: this.form.employeeSignature,
          signature: this.form.signature,
          images: this.form.images,
          details: this.form.details.map(d => ({
            productId: d.productId, productName: d.productName, quantity: Number(d.quantity) || 0
          }))
        }
        const wasRejected = this.form._origStatus === 2
        const doPut = () => {
          this.submitting = true
          axios.put('/outbound/' + this.form.id, body).then(res => {
            if (res.data && res.data.success) {
              this.$message.success(wasRejected ? '修改成功，已重新进入审核流程' : '修改成功')
              this.editVisible = false
              this.loadList()
            } else {
              this.$message.error((res.data && res.data.message) || '修改失败')
            }
          }).finally(() => { this.submitting = false })
        }

        const checkEditAndPrompt = (actualUpdateTime) => {
          if (actualUpdateTime) {
            const appTime = new Date(this.form.applicationTime || this.form.createTime || this.form.outboundDate)
            const baseTime = new Date(actualUpdateTime)
            if (appTime <= baseTime) {
              const isVipB = this.form.cardName === '尊贵卡B' || this.form.outboundType === '尊贵卡B'
              let delta = 0
              if (isVipB) {
                const oldAmt = Number(this.form._origAmt) || 0
                let newAmt = 0
                for (const d of body.details) {
                  const pOpt = (this.productOpts || []).find(p => p.id === d.productId || p.optKey === d.productOptKey)
                  const price = (d.price != null ? Number(d.price) : 0) || (pOpt && pOpt.price != null ? Number(pOpt.price) : 0)
                  newAmt += price * (Number(d.quantity) || 0)
                }
                delta = newAmt - oldAmt
              } else {
                const oldQty = Number(this.form._origQty) || 0
                const newQty = body.details.reduce((s, d) => s + (Number(d.quantity) || 0), 0)
                delta = newQty - oldQty
              }
              if (delta !== 0) {
                const impactText = isVipB
                  ? (delta > 0 ? `【减少 ¥${delta}】` : `【增加 ¥${Math.abs(delta)}】`)
                  : (delta > 0 ? `【减少 ${delta} 件】` : `【增加 ${Math.abs(delta)} 件】`)
                const promptMsg = `⚠️【历史基准联动影响提示】\n\n实际剩余时间基准已存在（最新基准时间：${String(actualUpdateTime).replace('T', ' ').slice(0, 19)}）。\n\n您的操作会影响现在的实际剩余数量：\n• 变动结果：实际剩余将 ${impactText}；\n• 变动原因：您修改了基准时间之前的历史申请数量/额度，系统自动联动调整当前手填基准。\n\n是否确定保存修改？`
                this.$confirm(promptMsg, '提示', { type: 'warning' })
                  .then(() => doPut())
                  .catch(() => { this.submitting = false })
                return
              }
            }
          }
          doPut()
        }

        let curActTime = this.form.actualUpdateTime
        if (!curActTime && this.form.orderId && Array.isArray(this.vipCardOptions)) {
          const cardSel = this.vipCardOptions.find(c => c.id === this.form.orderId)
          if (cardSel && cardSel.actualUpdateTime) curActTime = cardSel.actualUpdateTime
        }

        if (!curActTime && this.form.orderId) {
          axios.get('/order/' + this.form.orderId).then(res => {
            const o = res.data
            let actT = o ? o.actualUpdateTime : null
            if (!actT && o && Array.isArray(o.details)) {
              for (const d of o.details) {
                if (d.actualUpdateTime) { actT = d.actualUpdateTime; break }
              }
            }
            checkEditAndPrompt(actT)
          }).catch(() => checkEditAndPrompt(null))
        } else {
          checkEditAndPrompt(curActTime)
        }
      } else {
        // 新建：先按姓名找/建客户，再 submit
        this.resolveCustomerByName(name).then(customerId => {
          const me = JSON.parse(sessionStorage.getItem('user') || '{}')
          const body = {
            customerId,
            userId: this.form.salesmanId || me.id || null,
            approverId: this.form.approverId || null,
            outboundType: this.form.cardName,
            stockType: this.form.cardName === '送存货' ? (this.form.stockType || '普通存货') : null,
            applicableTypeId: this.form.applicableTypeId || null,
            applicableTypeName: this.form.applicableTypeName || null,
            verificationType: this.form.verificationType != null ? this.form.verificationType : 3,
            verifyPhone: this.form.verifyPhone || null,
            attachmentUrl: this.form.attachmentUrl || null,
            replenishType: this.form.replenishType,
            outboundDate: this.form.outboundDate || null,
            orderId: this.form.orderId || null,
            reason: this.form.reason,
            remark: this.form.remark,
            // 客户详情页（embedded）新建的提货申请不再自动审核，进审批管理手动审核；独立页保持原行为
            skipApproval: !this.embedded,
            details: this.form.details.map(d => ({
              productId: d.productId, productName: d.productName, quantity: Number(d.quantity) || 0
            }))
          }
          return axios.post('/outbound/submit', body)
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('新建成功')
            if (res.data.warning) {
              this.$message({ message: res.data.warning, type: 'warning', duration: 6000 })
            }
            this.editVisible = false
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '新建失败')
          }
        }).catch(err => {
          if (err && err.message) this.$message.error(err.message)
        }).finally(() => { this.submitting = false })
      }
    },
    addDetailRow() {
      if (this.isGiftOutbound && !this.form.applicableTypeId) {
        this.$message.warning('请先选择礼品类型')
        return
      }
      this.form.details.push({ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false })
    },
    loadGiftTypes() {
      axios.get('/gift-type/list', { params: { enabled: 1 } }).then(res => {
        const list = Array.isArray(res.data) ? res.data : []
        this.allGiftTypeOptions = list
        if (!this.isGiftOutbound || !this.form.customerName) {
          this.giftTypeOptions = list
        }
      }).catch(() => {
        this.allGiftTypeOptions = []
        this.giftTypeOptions = []
      })
    },
    checkCustomerGiftEligibility() {
      if (!this.isGiftOutbound) return
      const custName = (this.form.customerName || '').trim()
      const custId = this.form.customerId || (this.embeddedCustomer ? this.embeddedCustomer.id : null)
      if (!custName && !custId) {
        this.giftTypeOptions = this.allGiftTypeOptions.length ? [...this.allGiftTypeOptions] : []
        return
      }
      axios.get('/gift-recipient/customer-eligibility', {
        params: { customerId: custId || undefined, customerName: custName || undefined }
      }).then(res => {
        const data = res.data || {}
        if (data.eligible) {
          const allowed = data.allowedGiftTypes || []
          this.giftTypeOptions = allowed
          if (allowed.length === 1) {
            const single = allowed[0]
            if (this.form.applicableTypeId !== single.id) {
              this.form.applicableTypeId = single.id
              this.form.applicableTypeName = single.name
              if (!this.isOpeningEdit) {
                this.refreshVipProductOpts()
              }
            }
          } else if (this.form.applicableTypeId && !allowed.some(t => t.id === this.form.applicableTypeId)) {
            if (!this.isOpeningEdit) {
              this.form.applicableTypeId = null
              this.form.applicableTypeName = ''
            }
          }
        } else {
          this.giftTypeOptions = []
          if (!this.isOpeningEdit) {
            this.form.applicableTypeId = null
            this.form.applicableTypeName = ''
          }
          if (data.message && this.editVisible) {
            this.$message.warning(data.message)
          }
        }
      }).catch(err => {
        console.error('检查礼品资格失败:', err)
      })
    },
    onGiftTypeChange(typeId) {
      const type = (this.giftTypeOptions || []).find(t => t.id === typeId)
      this.form.applicableTypeName = type ? type.name : ''
      this.form.details = [{ productId: null, productName: '', quantity: 1, productOptKey: null, tipMessage: '', statusType: 'normal', canApply: true, limitExceeded: false, isUnlocked: false }]
      this.refreshVipProductOpts()
    },
    loadTrialTypes() {
      axios.get('/applicable-type/list', { params: { enabled: 1 } }).then(res => {
        this.trialTypeOptions = Array.isArray(res.data) ? res.data : []
      }).catch(() => { this.trialTypeOptions = [] })
    },
    loadCustomers() {
      axios.get('/customer/list').then(res => {
        const list = res.data || []
        const map = {}
        list.forEach(c => {
          if (c.name) map[c.name.trim()] = c.telephone || c.phone || ''
        })
        this.customerPhoneMap = map
      }).catch(() => {})
    },
    onTrialTypeChange(typeId) {
      const type = (this.trialTypeOptions || []).find(t => t.id === typeId)
      if (type) {
        this.form.applicableTypeName = type.name
        if (type.needVerification === 1) {
          if (!this.form.verificationType || this.form.verificationType === 3) {
            this.form.verificationType = 1
          }
          if (!this.form.verifyPhone) {
            let phone = ''
            if (this.embedded && this.embeddedCustomer) {
              phone = (this.embeddedCustomer.contactPhone || this.embeddedCustomer.telephone || this.embeddedCustomer.phone || '').trim()
            } else if (this.form.customerName && this.customerPhoneMap) {
              phone = (this.customerPhoneMap[this.form.customerName.trim()] || '').trim()
            }
            if (phone && /^1[3-9]\d{9}$/.test(phone) && !phone.startsWith('0000')) {
              this.form.verifyPhone = phone
            }
          }
        } else {
          this.form.verificationType = 3
        }
      } else {
        this.form.applicableTypeName = ''
        this.form.verificationType = 3
      }
      this.refreshVipProductOpts()
      this.recheckTrialDetails()
    },
    checkProductTrialLimit(d) {
      if (!this.isTrialOutbound || !d.productId) {
        this.$set(d, 'tipMessage', '')
        this.$set(d, 'statusType', 'normal')
        this.$set(d, 'canApply', true)
        this.$set(d, 'limitExceeded', false)
        this.$set(d, 'isUnlocked', false)
        return
      }
      const params = {
        productId: d.productId,
        productName: d.productName,
        applicableTypeId: this.form.applicableTypeId
      }
      if (this.form.customerId) {
        params.customerId = this.form.customerId
      } else if (this.form.customerName) {
        params.customerName = this.form.customerName.trim()
      }
      axios.get('/trial/check-product', { params }).then(res => {
        if (res.data && res.data.success) {
          this.$set(d, 'tipMessage', res.data.tipMessage || '')
          this.$set(d, 'statusType', res.data.statusType || 'normal')
          this.$set(d, 'canApply', res.data.canApply !== false)
          this.$set(d, 'limitExceeded', !!res.data.limitExceeded)
          this.$set(d, 'isUnlocked', !!res.data.isUnlocked)
        }
      }).catch(() => {})
    },
    recheckTrialDetails() {
      if (!this.isTrialOutbound) return
      (this.form.details || []).forEach(d => {
        if (d.productId) {
          this.checkProductTrialLimit(d)
        }
      })
    },
    getTrialTipStyle(d) {
      if (d.statusType === 'success' || d.isUnlocked) {
        return { color: '#67C23A', fontWeight: 'bold' }
      }
      if (d.statusType === 'warning' || (d.limitExceeded && !d.isUnlocked) || d.canApply === false) {
        return { color: '#F56C6C', fontWeight: 'bold' }
      }
      return { color: '#909399' }
    },
    sendSmsCode() {
      if (!this.form.verifyPhone || !/^1\d{10}$/.test(this.form.verifyPhone.trim())) {
        this.$message.error('请输入正确的11位手机号码')
        return
      }
      axios.post('/sms/send-trial-code', { phone: this.form.verifyPhone.trim() }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success(res.data.message || '验证码已发送')
          this.smsCountdown = 60
          if (this.smsTimer) clearInterval(this.smsTimer)
          this.smsTimer = setInterval(() => {
            this.smsCountdown--
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer)
              this.smsTimer = null
            }
          }, 1000)
        } else {
          this.$message.error((res.data && res.data.message) || '发送失败')
        }
      }).catch(err => {
        this.$message.error('发送验证码失败：' + (err.message || '网络错误'))
      })
    },
    customUploadVoucher(param) {
      const fd = new FormData()
      fd.append('file', param.file)
      axios.post('/file/upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        const data = res.data
        if (data && data.success !== false && data.url) {
          this.form.attachmentUrl = data.url
          this.form.attachmentName = param.file.name || data.originalFilename || data.filename || '凭证附件'
          this.$message.success('凭证上传成功')
          if (param.onSuccess) param.onSuccess(data)
        } else {
          this.$message.error((data && data.message) || '凭证上传失败')
          if (param.onError) param.onError(new Error((data && data.message) || '上传失败'))
        }
      }).catch(err => {
        this.$message.error('凭证上传失败：' + (err.message || '网络错误'))
        if (param.onError) param.onError(err)
      })
    },
    handleVoucherSuccess(res) {
      if (res && res.success && res.url) {
        this.form.attachmentUrl = res.url
        this.form.attachmentName = res.originalFilename || res.filename || '凭证附件'
        this.$message.success('凭证上传成功')
      } else {
        this.$message.error((res && res.message) || '凭证上传失败')
      }
    },
    beforeVoucherUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('凭证文件大小不能超过 20MB!')
      }
      return isLt20M
    },
    removeVoucher() {
      this.form.attachmentUrl = ''
      this.form.attachmentName = ''
    },
    previewOrDownload(url) {
      if (!url) return
      if (this.isImageFile(url)) {
        window.open(this.full(url), '_blank')
      } else {
        const downloadApiUrl = this.full('/api/file/download?url=' + encodeURIComponent(url))
        window.open(downloadApiUrl, '_blank')
      }
    },
    resolveCustomerByName(name) {
      // 拉客户列表（已通过 dedupe 保证唯一），找姓名匹配
      return axios.get('/customer/list').then(res => {
        const list = res.data || []
        const hit = list.find(c => c.name === name)
        if (hit) return hit.id
        // 找不到：报错并返回 null（不再自动新建空名/重复客户，避免产生脏数据）
        this.$message.error('系统中找不到客户「' + name + '」，请先到客户管理新建')
        return Promise.reject(new Error('customer-not-found'))
      })
    },
    handleDispatch(row) {
      this.$confirm('确认出库该订单？将扣减库存并写入出库记录', '提示', { type: 'warning' }).then(() => {
        axios.post('/outbound/' + row.id + '/dispatch').then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已出库')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '出库失败')
          }
        })
      }).catch(() => {})
    },
    handleCancel(row) {
      // 撤销仅限超级管理员，行政管理员/业务员点击给出明确提示
      const me = (function () { try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} } })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      if (!isSuper) {
        this.$message.warning('仅超级管理员可以撤销提货申请，请联系超级管理员操作')
        return
      }
      const doCancel = (confirmMsg) => {
        this.$confirm(confirmMsg, '提示', { type: 'warning' }).then(() => {
          axios.post('/outbound/' + row.id + '/cancel').then(res => {
            if (res.data && res.data.success) {
              this.$message.success('撤销成功')
              this.loadList()
            } else {
              this.$message.error((res.data && res.data.message) || '撤销失败')
            }
          })
        }).catch(() => {})
      }

      let defaultMsg = '确定撤销该记录？撤销后申请将立即作废且不产生任何扣减；此前占用的存货数量、领取上限及额度将自动释放；若已扣减公司库存，将一并退回。记录将永久保留并标记为“已撤销”，该操作不可恢复。'

      const checkCancelAndPrompt = (actualUpdateTime) => {
        if (actualUpdateTime) {
          const appTime = new Date(row.applicationTime || row.createTime || row.outboundDate)
          const baseTime = new Date(actualUpdateTime)
          if (appTime <= baseTime) {
            const isVipB = row.cardName === '尊贵卡B' || row.outboundType === '尊贵卡B'
            const qVal = (row.details && row.details.length) ? row.details.reduce((s, d) => s + (Number(d.quantity) || 0), 0) : (row.totalQuantity || 0)
            const qtyOrAmt = isVipB ? (`¥${row.totalAmount || 0}`) : (`${qVal} 件`)
            defaultMsg = `⚠️【历史基准联动影响提示】\n\n实际剩余时间基准已存在（最新基准时间：${String(actualUpdateTime).replace('T', ' ').slice(0, 19)}）。\n\n您的操作会影响现在的实际剩余数量：\n• 变动结果：实际剩余将 【增加 ${qtyOrAmt}】；\n• 变动原因：历史扣减已撤销释放，自动联动加回当前手填基准。\n\n` + defaultMsg
          }
        }
        doCancel(defaultMsg)
      }

      if (row.orderId) {
        axios.get('/order/' + row.orderId).then(res => {
          const o = res.data
          let actTime = o ? o.actualUpdateTime : null
          if (!actTime && o && Array.isArray(o.details)) {
            for (const d of o.details) {
              if (d.actualUpdateTime) { actTime = d.actualUpdateTime; break }
            }
          }
          checkCancelAndPrompt(actTime || row.actualUpdateTime)
        }).catch(() => checkCancelAndPrompt(row.actualUpdateTime))
      } else {
        checkCancelAndPrompt(row.actualUpdateTime)
      }
    },
    handleDelete(row) {
      this.$confirm('确定删除该记录？仅从列表中删除此条记录，不涉及任何库存或额度变动，删除后不可恢复。', '提示', { type: 'warning' }).then(() => {
        axios.delete('/outbound/' + row.id).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '删除失败')
          }
        })
      }).catch(() => {})
    },
    openChangeLog(row) {
      axios.get('/outbound/' + row.id + '/change-log').then(res => {
        this.changeLogs = res.data || []
        this.changeLogVisible = true
      })
    },
    // 欠款取值：仅"新出库"在 debt 缺失时回落 totalAmount；其它类型严格只看 row.debt
    getDebtForRow(row) {
      if (row.debt != null && row.debt !== '') return Number(row.debt) || 0
      if (row && row.cardName === '新出库' && row.totalAmount != null) return Number(row.totalAmount) || 0
      return 0
    },
    // 新出库 修改欠款：欠款=0 自动置已完结(3)，>0 置未完结(4)
    changeDebt(row) {
      const curDebt = this.getDebtForRow(row)
      this.$prompt(`请输入欠款金额（当前 ¥${curDebt}；填 0 自动置「已完结」，>0 置「未完结」）`, '修改欠款', {
        inputValue: String(curDebt),
        inputType: 'text',
        inputValidator: v => {
          const n = Number(v)
          return (!isNaN(n) && n >= 0) || '请输入 ≥0 的数字'
        },
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        const debt = Number(value)
        const newStatus = debt === 0 ? 3 : 4
        axios.post('/outbound/' + row.id + '/status', { status: newStatus, debt: debt }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已更新（' + (newStatus === 3 ? '已完结' : '未完结') + '，欠款 ¥' + debt + '）')
            this.loadList()
          } else {
            this.$message.error((res.data && res.data.message) || '修改失败')
          }
        })
      }).catch(() => {})
    },
    // 从后端 /user/info 拉一次当前用户真实角色（不依赖 sessionStorage 缓存）
    loadCurrentUser() {
      axios.get('/user/info').then(res => {
        if (res.data && res.data.user) this.currentUser = res.data.user
      }).catch(() => {})
    },
    loadSalesmen(outboundType) {
      // 拥有该出库类型权限的业务员（roleId=3 + status=1）。outboundType 为空时返回全部启用业务员。
      const params = {}
      if (outboundType) params.outboundType = outboundType
      axios.get('/user/salesmen', { params }).then(res => {
        const data = res.data || []
        this.salesmanOptions = Array.isArray(data) ? data : []
        if (this.embedded && this.embeddedCustomer && this.embeddedCustomer.responsiblePerson) {
          const resp = String(this.embeddedCustomer.responsiblePerson).trim()
          const matched = this.salesmanOptions.find(u => (u.name && u.name.trim() === resp) || (u.username && u.username.trim() === resp))
          if (matched) {
            this.form.salesmanId = matched.id
          } else {
            axios.get('/user/list').then(uRes => {
              const allUsers = (uRes.data && (uRes.data.list || uRes.data)) || []
              const hit = allUsers.find(u => (u.name && u.name.trim() === resp) || (u.username && u.username.trim() === resp))
              if (hit) {
                if (!this.salesmanOptions.find(u => Number(u.id) === Number(hit.id))) {
                  this.salesmanOptions.push(hit)
                }
                this.form.salesmanId = hit.id
              }
            }).catch(() => {})
          }
        } else {
          // 已选业务员若不在新列表中则清空
          if (this.form.salesmanId && !this.salesmanOptions.find(u => Number(u.id) === Number(this.form.salesmanId))) {
            this.form.salesmanId = null
          }
        }
      }).catch(() => { this.salesmanOptions = [] })
    },
    loadAdmins(outboundType) {
      // 拥有该出库类型权限的行政管理员（roleId=2 + status=1）。outboundType 为空时返回全部启用管理员。
      const params = {}
      if (outboundType) params.outboundType = outboundType
      axios.get('/user/auditors', { params }).then(res => {
        const data = res.data || []
        this.adminOptions = Array.isArray(data) ? data : []
        // 已选审核员若不在新列表中则清空
        if (this.form.approverId && !this.adminOptions.find(u => Number(u.id) === Number(this.form.approverId))) {
          this.form.approverId = null
        }
      }).catch(() => { this.adminOptions = [] })
    },
    // 修改权限：
    //  ① 已出库 → 整单不能改（status=3 已完结；新出库 status=4 未完结=货已发欠款未清，也算已出库）
    //  ② 超级管理员登录看自己建的 → 出库前可改整单
    //  ③ 其他 → 只有审核中(0)/已驳回(2) 可改
    //  （新出库 status=4 时，欠款仍可通过状态 tag 上的"修改欠款"入口单独改，整单按钮另行控制）
    canEditRow(row) {
      const st = Number(row && row.status)
      if (st === 6) return false
      if (st === 3) return false
      if (row && row.cardName === '新出库' && st === 4) return false
      const me = this.currentUser || (function () {
        try { return JSON.parse(sessionStorage.getItem('user') || '{}') } catch (e) { return {} }
      })()
      const isSuper = me && (me.role === 'super_admin' || me.role === '超级管理员' || Number(me.roleId) === 1)
      const isOwnBySuper = isSuper && me.id != null && Number(me.id) === Number(row.userId)
      if (isOwnBySuper) return true
      return st === 0 || st === 2
    },
    // 与审批管理一致：礼品/试用 1=已通过、5=待出库；新出库 4=未完结
    statusLabel(type, s) {
      // 兼容旧调用（只传 status）
      if (arguments.length === 1) { s = type; type = null }
      const isGiftOrTrial = type === '礼品' || type === '试用' || type === '产品试用'
      const m = {
        0: '审核中',
        1: isGiftOrTrial ? '待出库' : '待签字',
        2: '已驳回',
        3: '已完结',
        4: '未完结',
        5: isGiftOrTrial ? '待出库' : '已签字（待出库）',
        6: '已撤销'
      }
      return m[s] != null ? m[s] : s
    },
    statusTag(type, s) {
      if (arguments.length === 1) { s = type }
      // 新出库 + 未完结 → 红色醒目
      if (type === '新出库' && Number(s) === 4) return 'danger'
      const m = { 0: 'warning', 1: 'primary', 2: 'danger', 3: 'success', 4: 'info', 5: 'warning', 6: 'info' }
      return m[s] || ''
    },
    cardTag(c) {
      let rawRow = null
      if (c && typeof c === 'object') {
        rawRow = c
        c = c.cardName || c.outboundType || c.category
      }
      if (c === '送存货' || c === '普通存货' || c === '品鉴存货' || c === '试用存货') return 'warning'
      if (this.isGiftOutboundType(c, rawRow)) return 'danger'
      if (c === '试用' || c === '产品试用') return 'success'
      if (c === '新出库') return 'info'
      if (c === '尊贵卡A') return 'warning' // tag-vip-a 覆盖为金
      if (c === '尊贵卡B') return 'primary'
      if (c === '尊贵卡C') return 'info'    // tag-vip-c 覆盖为紫
      return ''
    },
    cardClass(c) {
      if (c && typeof c === 'object') {
        c = c.cardName || c.outboundType || c.category
      }
      if (c === '尊贵卡A') return 'tag-vip-a'
      if (c === '尊贵卡B') return 'tag-vip-b'
      if (c === '尊贵卡C') return 'tag-vip-c'
      if (c === '新出库') return 'tag-newout'
      return ''
    },
    formatDate(v, len) {
      if (!v) return ''
      const s = String(v).replace('T', ' ')
      return s.slice(0, len || 19)
    },
    sumRemainingStock(row) {
      if (!row || !row.details) return 0
      return row.details.reduce((s, d) => s + (Number(d.remainingStock) || 0), 0)
    },
    rowQty(row) {
      if (!row || !row.details) return 0
      return row.details.reduce((s, d) => s + (Number(d.quantity) || 0), 0)
    },
    /** 产品内容：显示"产品 ×数量"，多产品用、分隔；尊贵卡A/B/C 加"尊贵卡-"前缀（不重叠）；无明细(如尊贵卡B)回落 productNames */
    prodContent(row) {
      const ds = (row && row.details) || []
      if (!ds.length) return (row && row.productNames) ? row.productNames : '-'
      const isVip = ['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(row && row.cardName)
      const parts = ds.filter(d => d && d.productName).map(d => {
        let n = String(d.productName || '')
        if (isVip && n && !n.startsWith('尊贵卡-')) n = '尊贵卡-' + n
        return n + ' ×' + (d.quantity != null ? d.quantity : 0)
      })
      return parts.length ? parts.join('、') : ((row && row.productNames) ? row.productNames : '-')
    },
    /** 产品内容（不带数量版）：客户详情页内嵌的列表列用，只显产品名；展开/详情仍用 prodContent 带数量 */
    prodContentNoQty(row) {
      const ds = (row && row.details) || []
      if (!ds.length) return (row && row.productNames) ? row.productNames : '-'
      const isVip = ['尊贵卡A', '尊贵卡B', '尊贵卡C'].includes(row && row.cardName)
      const parts = ds.filter(d => d && d.productName).map(d => {
        let n = String(d.productName || '')
        if (isVip && n && !n.startsWith('尊贵卡-')) n = '尊贵卡-' + n
        return n
      })
      return parts.length ? parts.join('、') : ((row && row.productNames) ? row.productNames : '-')
    },
    detailSummary({ columns, data }) {
      const sums = []
      columns.forEach((col, idx) => {
        if (idx === 0) { sums[idx] = '汇总'; return }
        const key = col.property
        if (key === 'quantity' || key === 'stockLimit' || key === 'stockQuantity' || key === 'remainingStock') {
          const total = (data || []).reduce((s, r) => s + (Number(r[key]) || 0), 0)
          sums[idx] = total
          return
        }
        if (col.label === '实付') {
          const total = (data || []).reduce((s, r) => s + (Number(r.actualAmount) || 0), 0)
          sums[idx] = '¥' + total.toFixed(2)
          return
        }
        sums[idx] = ''
      })
      return sums
    },
    // 服务期限 = 当前未缴年度的缴费截止日（nextDue），与销售订单"服务费到期提醒"同算法但不减 warnDays
    // row._setOverdue(overdue, warning) 可选回调：返回是否逾期和提示文案
    computeServiceDueDate(row) {
      if (!row) return ''
      const start = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!start) return ''
      const parts = start.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const paid = new Set(
        String(row.serviceFeePaidYears || '')
          .split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n))
      )
      let cur = new Date(parts[0], parts[1] - 1, parts[2])
      let nextDue = null
      for (let i = 0; i < 200; i++) {
        if (!paid.has(cur.getFullYear())) { nextDue = new Date(cur.getTime()); break }
        cur.setFullYear(cur.getFullYear() + 1)
      }
      if (!nextDue) return ''
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const daysToDue = Math.round((nextDue - today) / 86400000)
      if (daysToDue < 0) {
        const bufferDays = this.calcBufferDays()
        const overdueDays = -daysToDue
        // 区分缓冲期内和超过缓冲期的提示语
        if (overdueDays < bufferDays) {
          // 缓冲期内：即将休眠
          const remainingDays = bufferDays - overdueDays
          if (row._setOverdue) row._setOverdue(true, `⚠️ 服务费已逾期 ${overdueDays} 天（缓冲期剩余 ${remainingDays} 天），当前实际剩余配额/额度受限，请及时缴纳服务费。`)
        } else {
          // 超过缓冲期：已休眠
          if (row._setOverdue) row._setOverdue(true, `⚠️ 【休眠警示】该卡已进入【休眠状态】！因本年度服务费未缴纳，当前实际剩余为 0，暂不可办理出库！请先补交服务费。`)
        }
        return `已逾期 ${overdueDays} 天`
      }
      const warnDays = Number(row.expiryWarningDays) > 0 ? Number(row.expiryWarningDays) : 30
      if (daysToDue <= warnDays && row._setOverdue) {
        row._setOverdue(false, `ℹ️ 服务费即将到期（剩 ${daysToDue} 天），请尽快缴纳服务费以释放下一年度实际剩余配额。`)
      }
      const displayDue = new Date(nextDue.getTime() - 86400000)
      const yyyy = displayDue.getFullYear()
      const mm = String(displayDue.getMonth() + 1).padStart(2, '0')
      const dd = String(displayDue.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 旧用法（详情抽屉等位置）保留：返回 start 至 end 区间
    computeServiceTerm(row) {
      const start = String((row && row.serviceFeeStartDate) || '').slice(0, 10)
      const end = this.computeServiceDueDate(row)
      if (!start || !end) return ''
      return start + ' 至 ' + end
    },
    // 与销售订单页完全一致：合同服务期限 / 服务费到期提醒
    contractServiceTerm(row) {
      if (!row) return ''
      const start = String(row.serviceFeeStartDate || '').slice(0, 10)
      if (!start) return ''
      const end = row.serviceFeeEndDate
        ? String(row.serviceFeeEndDate).slice(0, 10)
        : this.deriveServiceEndDate(row.serviceFeeStartDate, row.freeServicePeriod)
      if (!end) return ''
      return start + ' 至 ' + end
    },
    deriveServiceEndDate(startDate, period) {
      const start = String(startDate || '').slice(0, 10)
      const p = (period || '').trim()
      if (!start || !p) return ''
      const m = p.match(/^(\d+)\s*(年|个月|月|天|日)$/)
      if (!m) return ''
      const n = Number(m[1])
      const u = m[2]
      const d = new Date(start.replace(/-/g, '/'))
      if (isNaN(d.getTime())) return ''
      if (u === '年') d.setMonth(d.getMonth() + n * 12)
      else if (u === '个月' || u === '月') d.setMonth(d.getMonth() + n)
      else d.setDate(d.getDate() + n)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 免服务费剩余天数 = max(0, 服务费起始日 - today)（与 SalesOrder.vue 同口径）
    computeFreeServiceDaysLeft(row) {
      if (!row) return '-'
      const feeStartStr = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!feeStartStr) return '-'
      const parts = feeStartStr.split('-').map(Number)
      const feeStart = new Date(parts[0], parts[1] - 1, parts[2])
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const diff = Math.ceil((feeStart - today) / 86400000)
      if (diff <= 0) return '0 天（已开始计费）'
      return diff + ' 天'
    },
    // 工具：合同起始日 + 免服务期月数 → 派生服务费起始日（与 SalesOrder.vue 同口径）
    computeServiceFeeStart(contractStartDate, freeMonths) {
      const s = String(contractStartDate || '').slice(0, 10)
      if (!s) return ''
      const parts = s.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const d = new Date(parts[0], parts[1] - 1, parts[2])
      if (isNaN(d.getTime())) return ''
      const m = Number(freeMonths) > 0 ? Number(freeMonths) : 0
      d.setMonth(d.getMonth() + m)
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    // 服务费到期提醒：与后端 scanVipBCServiceFeeDue 同口径，找下一个未缴年度槽起点
    serviceRemindDate(row) {
      if (!row) return ''
      const start = this.computeServiceFeeStart(row.serviceFeeStartDate, row.freeServiceMonths)
      if (!start) return ''
      const parts = start.split('-').map(Number)
      if (parts.length < 3 || parts.some(isNaN)) return ''
      const paid = new Set(
        String(row.serviceFeePaidYears || '')
          .split(',').map(s => s.trim()).filter(Boolean).map(Number).filter(n => !isNaN(n))
      )
      let cur = new Date(parts[0], parts[1] - 1, parts[2])
      let nextDue = null
      for (let i = 0; i < 200; i++) {
        if (!paid.has(cur.getFullYear())) { nextDue = new Date(cur.getTime()); break }
        cur.setFullYear(cur.getFullYear() + 1)
      }
      if (!nextDue) return ''
      const today = new Date(); today.setHours(0, 0, 0, 0)
      const daysToDue = Math.round((nextDue - today) / 86400000)
      if (daysToDue < 0) return `已逾期 ${-daysToDue} 天`
      const warnDays = Number(row.expiryWarningDays) > 0 ? Number(row.expiryWarningDays) : 30
      const remind = new Date(nextDue.getTime())
      remind.setDate(remind.getDate() - warnDays)
      return this.fmtYMD(remind)
    },
    fmtYMD(d) {
      const yyyy = d.getFullYear()
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const dd = String(d.getDate()).padStart(2, '0')
      return `${yyyy}-${mm}-${dd}`
    },
    isImageFile(url) {
      if (!url) return false
      return /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(url)
    },
    downloadAttachment(url) {
      if (!url) return
      const downloadApiUrl = '/api/file/download?url=' + encodeURIComponent(url)
      window.open(downloadApiUrl, '_blank')
    },
    full(url) {
      if (!url) return ''
      if (/^(https?:|data:)/i.test(url)) return url
      const base = (axios.defaults.baseURL || '').replace(/\/api\/?$/, '')
      return base + url
    },
    exportCsv() {
      const cols = ['订单ID', '申请单号', '客户姓名', '出库类型', '产品内容', '免服务费期限', '服务费起始日', '总实付金额', '销售日期', '总存货数量', '剩余存货数量', '欠款', '订单状态', '审核员', '申请备注']
      const rows = this.orderList.map(o => [
        o.id, o.applicationNo || '', o.customerName || '', this.vipCardLabel(o) || o.cardName || '',
        o.productNames || '',
        o.freeServicePeriod || '', this.formatDate(o.serviceFeeStartDate, 10),
        o.totalAmount || 0, this.formatDate(o.createTime),
        o.stockQuantity != null ? o.stockQuantity : 0,
        this.sumRemainingStock(o),
        o.debt != null ? o.debt : '',
        this.statusLabel(o.status), o.approverName || '', o.remark || ''
      ].map(v => v == null ? '' : String(v).replace(/,/g, '，')))
      const csv = '\uFEFF' + [cols.join(','), ...rows.map(r => r.join(','))].join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '尊贵卡订单_' + new Date().toISOString().slice(0, 10) + '.csv'
      link.click()
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; text-align: right; }
.muted { color: #909399; }
.small { font-size: 12px; }
.strong { color: #67c23a; font-weight: 600; }
.section-title { margin: 16px 0 8px; font-size: 13px; font-weight: 600; color: #303133; }
.img-list { display: flex; flex-wrap: wrap; }

.detail-panel { padding: 14px 24px 18px; background: linear-gradient(180deg,#fafcff 0%,#f5f7fa 100%); border-top: 1px dashed #dcdfe6; }
.detail-panel-title { display: flex; align-items: center; gap: 6px; color: #303133; font-size: 13px; font-weight: 600; margin: 4px 0 12px; }
.detail-panel-title i { color: #409eff; }
.detail-grid { display: flex; flex-direction: column; gap: 10px; }
.detail-card-row { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.02); padding: 12px 14px; margin-bottom: 12px; }
.detail-card-head { display: flex; align-items: center; gap: 14px; padding-bottom: 8px; margin-bottom: 8px; border-bottom: 1px dashed #ebeef5; }
.dc-no { color: #fff; background: #409eff; padding: 2px 8px; border-radius: 10px; font-size: 12px; font-weight: 600; }
.dc-name { color: #303133; font-weight: 600; font-size: 14px; }
.dc-spec { color: #909399; font-size: 12px; }
.detail-card-body { display: grid; grid-template-columns: repeat(8, 1fr); gap: 8px; }
.detail-card-body.cols-4 { grid-template-columns: repeat(4, 1fr); }
.dc-cell.w4 { grid-column: span 4; }
.dc-value.strong { color: #67c23a; font-weight: 600; }
.sig-row { display: flex; gap: 10px; margin-top: 12px; flex-wrap: wrap; }
.sig-block { flex: 0 0 auto; min-width: 160px; max-width: 220px; background: #fafcff; border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; }
.sig-block .section-title { margin-top: 0; font-size: 12px; }
/* 高亮：剩余额度 / 服务期限 */
.dc-cell.highlight { background: #fff7e6; border: 1px solid #ffd591; }
.dc-cell.highlight .dc-label { color: #d46b08; font-weight: 600; }
.dc-value.highlight-value { color: #d46b08; font-weight: 700; font-size: 14px; }
::v-deep .hl-label { background: #fff7e6 !important; color: #d46b08 !important; font-weight: 600; }
::v-deep .hl-content { background: #fff7e6 !important; color: #d46b08 !important; font-weight: 700; }
.dc-cell.w4 { grid-column: span 4; }
.dc-cell { display: flex; justify-content: flex-start; align-items: center; gap: 8px; padding: 6px 10px; background: #f8f9fb; border-radius: 4px; }
.dc-cell.w4 { grid-column: span 4; }
.dc-label { color: #909399; font-size: 12px; flex-shrink: 0; }
.dc-label::after { content: '：'; }
.dc-value { color: #303133; font-size: 13px; font-weight: 500; }
.dc-value.strong { color: #67c23a; font-weight: 600; }
.detail-card { background: #f8f9fb; padding: 8px 12px; border-radius: 4px; margin-bottom: 8px; }
.sig-cell { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.sig-thumb { width: 80px; height: 80px; border: 1px solid #ebeef5; border-radius: 4px; }
.sig-thumb-mini { width: 56px; height: 56px; border: 1px solid #ebeef5; border-radius: 4px; margin: 2px; }
.sig-thumbs { display: flex; flex-wrap: wrap; max-width: 280px; }
.cl-files { display: flex; flex-wrap: wrap; }
/* 类型标签自定义色（金色 A / 紫色 C），与销售订单模块保持一致 */
::v-deep .el-tag.tag-vip-a {
  background-color: #fff1b8 !important;
  border-color: #faad14 !important;
  color: #874d00 !important;
  font-weight: 600 !important;
}
::v-deep .el-tag.tag-vip-c {
  background-color: #f4ecfb !important;
  border-color: #d3b4f1 !important;
  color: #722ed1 !important;
}
::v-deep .el-tag.tag-vip-b {
  background-color: #fff0f6 !important;
  border-color: #ff85c0 !important;
  color: #c41d7f !important;
}
::v-deep .el-tag.tag-newout {
  background-color: #e6fffb !important;
  border-color: #5cdbd3 !important;
  color: #08979c !important;
}
.select-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 2px;
}
.select-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
  margin-top: 2px;
}
.history-replenish-dialog-banner {
  margin: -8px 0 14px 100px;
  padding: 10px 14px;
  background: #FFF7E6;
  border: 1px solid #FFE7BA;
  border-left: 4px solid #faad14;
  border-radius: 4px;
  color: #d46b08;
  font-size: 12px;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>

<style>
.sales-order-date-popper {
  z-index: 99999 !important;
}
</style>
